webpackJsonp([1],{

/***/ "0fkY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BpBR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EUPG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GT0P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-analytics/dist/vue-analytics.js
var vue_analytics = __webpack_require__("AYPi");
var vue_analytics_default = /*#__PURE__*/__webpack_require__.n(vue_analytics);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3395e3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("0fkY")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dc8f292","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("ZQhR")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3190bf5a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("QkI9")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-3190bf5a"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-772adcfe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"},on:{"click":_vm.toggleContents}},[_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("WN8W")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-772adcfe"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba2690a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("NZMO")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-ba2690a0"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a441386","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("oPvi")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c0d9e23","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("i9d8")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd022a4c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("uDJ7")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: []
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36923708","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("eJtY")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74b6e97a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("Pg37")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48277a17","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("EUPG")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage'])),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-883f7ca2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1))]),_vm._v(" "),_c('p',{staticClass:"contents-item__text--title"},[_vm._v(_vm._s(_vm.page[0].title))]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("T53c")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'basePath', 'currentPage', 'showContents']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14d3008a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("U2l4")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$ga) {
      Publish.$ga.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e5c2ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("V6ic")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1f72b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-745923cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("pXbK")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22bcc19e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("Zf2O")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10484467","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("S4/L")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-10484467"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c172f84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n                            c-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n                            c-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n                            h85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n                            c-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n                            M123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n                            c-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n                            c-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n                            c0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n                            c6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n                            c3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n                            c-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n                            C70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n                            c-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n                            c6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n                            c14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n                            L154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("GT0P")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94cb9f4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("BpBR")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2b54d16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{attrs:{"to":_vm.nextPageURI,"classes":"navigation-link--next"}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("tGyY")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Revue Olympique - Numero 89",
  "shortTitle": "",
  "description": "",
  "width": 800,
  "height": 900,
  "currentLanguage": "FR",
  "languages": [{
    code: "EN",
    text: "English",
    href: "http://olympicreview.touchlines.com/89"
  }, {
    code: "FR",
    text: "French",
    href: "http://revueolympique.touchlines.com/89"
  }],
  "basePath": "/89",
  "companyLogo": "logo.png",
  "publishURL": "http://revueolympique.touchlines.com/89/static/thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": true,
    "downloadPath": 'http://revueolympique.touchlines.com/89/static/_content/revue-olympique-89.pdf',
    "printEnabled": false,
    "zoomEnabled": true,
    "contentsEnabled": true,
    "languagesEnabled": true,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {}
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLink\" style=\"top:812px;left:665px;width:126px;height:77px;\">\n        <a href=\"https://www.olympic.org/\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n      function onPageEnter() {\n        setTimeout(function(){\n          addContentLinks();\n        }, 1000);\n      }\n\n      function onPageLeave() {\n        removeContentLinks();\n      }\n      ",
    "searchText": "PUBLICATION OFFICIELLE DU MOUVEMENT OLYMPIQUE  OLYMPIQUE OCTOBRE-NOVEMBRE-DÉCEMBRE 2013 NUMÉRO 89  Hivernaux. Chaleureux. Pour toi. Les meilleurs athlètes des sports d’hiver du monde entier finissent de se préparer en vue des Jeux à Sotchi alors que la station elle-même, située au bord de la mer Noire, s’apprête à accueillir les supporters du monde entier, pour célébrer ensemble l’excellence sportive.  WWW.OLYMPIC.ORG"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "REVUE OLYMPIQUE  SOMMAIRE PUBLICATION OFFICIELLE DU MOUVEMENT OLYMPIQUE OCTOBRE-NOVEMBRE-DECEMBRE 2013  07 AVANT-PROPOS  Par le président du CIO, Thomas Bach.  08 INSTANTANÉS  Images sportives captivantes du trimestre écoulé.  13 ACTUALITÉS  Les dernières nouvelles du Mouvement olympique.  24 PRENDRE LE RELAIS  La Revue Olympique s’entretient avec Thomas Bach, nouveau président du CIO et premier champion olympique à occuper cette fonction.  30 IMAGES OLYMPIQUES CLASSIQUES  Images saisissantes des Jeux passés, également en pages 52 et 58.  32 DOSSIER: SOTCHI 2014  Tandis que la Russie se prépare à accueillir les Jeux Olympiques d’hiver pour la première fois, la Revue Olympique révèle ce à quoi peuvent s’attendre les athlètes et leurs fans, et notamment les nouvelles épreuves sportives au programme (page 42) ainsi que les incroyables sites olympiques (page 46).  54 TOKYO 2020  Jack Gallagher du Japan Times revient sur le succès de la candidature de Tokyo à l’organisation des Jeux Olympiques de 2020 et s’entretient avec Tsunekazu Takeda, responsable de la candidature.  60 STARS DE SOTCHI  La skieuse alpine slovène, Tina Maze, et la star américaine de hockey sur glace, Kacey Bellamy, révèlent les secrets de leurs talents alors qu’elles se préparent pour les Jeux.  64 RECHERCHE OLYMPIQUE  Joanna Hunter explore comment le Centre d’Études Olympiques encourage la recherche universitaire au sein du Mouvement olympique.  68 SOLIDARITÉ OLYMPIQUE  De nouveaux athlètes expliquent ici comment leur bourse olympique les aide sur la route de Sotchi 2014.  74 MES JEUX  Le légendaire hockeyeur russe, Vladislav Tretiak, revient sur son illustre carrière olympique qui l’a vu remporter trois médailles d’or et une d’argent.  79 DÉCÈS  Olympiens et personnalités du Mouvement olympique récemment disparus.  80 SÉLECTION DE LIVRES  L’actualité des publications olympiques et sportives.  82 ESPRIT OLYMPIQUE  Découvrez la détermination du cavalier canadien, Ian Millar, spécialiste du saut d’obstacles.  4 REVUE OLYMPIQUE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "REVUE OLYMPIQUE  GÜNTER DEISTER COMMISSION EXÉCUTIVE Président Thomas Bach Vice-présidents Nawal El Moutawakel, Craig Reedie, John Coates Membres Sam Ramsamy, Gunilla Lindberg, Ching-Kuo Wu, René Fasel, Patrick Joseph Hickey, Claudia Bokel, Juan Antonio Samaranch Jr, Sergey Bubka, Willi Kaltschmitt Luján, Anita L. DeFrantz REVUE OLYMPIQUE  Directeur de la communication Mark Adams Rédactrice en chef Kathleen Di Giacomo Édition française Aurélie Eichler Édition espagnole Dolores Vázquez Agence de production Touchline Responsable de production Glyn Wilmshurst, Michael Stoneman Maquette John Paul Yetton, Liam Yeoh Image Jason Dutch Secrétariat de rédaction Sylvie Venet-Tupy Traduction Denis Echard, Laura Nadal Obrador, Ros Schwartz Relecture Libero Language Lab ISSN: 0377-192X Imprimé au Royaume-Uni IMAGES Couverture Getty Images Intérieur CIO; CIO/ Ian Jones; CIO/ Mikhail Mordasov; CIO/ Richard Juilliart; CIO/ Arnaud Meylan; CIO/ Vincent Calmel; Sochi 2014; Corbis; Kai-Uwe Wärner/dpa/Corbis; Getty Images; AFP; biathlon.com.ua  Journaliste, Günter a passé 31 ans à la tête du service des sports de l’Agence de presse allemande DPA. Il a ainsi couvert 22 éditions des Jeux d’été et d’hiver depuis 1968 et a été membre de la commission de presse du CIO de 1992 à 1998. Il dresse le portrait de Thomas Bach, nouveau président du CIO, en page 24.  BRIAN PINELLI Brian, qui couvrira ses cinquièmes Jeux Olympiques d’hiver en 2014, présente, en page 32, la manifestation qui s’annonce à Sotchi. Lui-même passionné de ski, il réside à Prague et a collaboré à l’International Herald Tribune, Around the Rings, au New York Times, à FISAlpine.com, Ski Racing, Snow Magazine, USAHockey.com, Universal Sports, CBS Sports et CNN World Sport.  COORDONNÉES Écrivez-nous à: Revue Olympique, Département de la Communication du CIO, Château de Vidy, 1007 Lausanne, Suisse. www.olympic.org, olympicreview@olympic.org tél. +41 (0)21 621 6111 fax +41 (0)21 621 6356 La Revue Olympique est imprimée sur du papier certifié PEFC fabriqué à partir de bois de forêts gérées dans le souci du développement durable. La Revue Olympique est publiée par le Comité International Olympique. Les articles publiés dans la Revue Olympique ne reflètent pas nécessairement l’opinion du CIO. Toute reproduction sans l’accord du CIO est interdite.  JOANNA HUNTER Journaliste indépendante, Joanna a collaboré au Times, Guardian, New Statesman, Sydney Morning Herald et au South China Morning Post. En page 64, elle présente comment le Centre d’Études Olympiques encourage activement la recherche universitaire au sein du Mouvement olympique.  REVUE OLYMPIQUE 5"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "AVANT-PROPOS  AVANT-PROPOS DE  THOMAS BACH  PRÉSIDENT DU COMITÉ INTERNATIONAL OLYMPIQUE  En haut, à droite: les Jeux Olympiques d’hiver auront lieu pour la première fois en Russie, à Sotchi en 2014.  N  ous sommes à quelques semaines des Jeux Olympiques d’hiver de 2014. L’effervescence et l’enthousiasme prennent toute leur ampleur! Les derniers préparatifs sont réalisés à bride abattue à Sotchi. Pour les athlètes, c’est le moment des rêves ultimes dans la perspective de la plus grande expérience de leur carrière sportive. Les Jeux Olympiques sont l’élément central et la raison d’être du Comité International Olympique. Ils sont l’occasion pour les meilleurs athlètes d’incarner les valeurs olympiques d’excellence, d’amitié et de respect sur la scène mondiale. Ils sont une célébration de la diversité qui promeut l’unité d’esprit. Organiser les Jeux est une tâche monumentale. Il s’agit de maintenir l’équilibre entre une prise en charge appropriée et la possibilité de laisser la magie des Jeux opérer par le biais de la culture et des traditions de la ville hôte. Les visiteurs qui se rendront à Sotchi ne seront pas seulement les témoins de performances sportives remarquables, ils découvriront également l’histoire culturelle et le patrimoine russes et caucasiens.  La diversité des villes hôtes est une contribution majeure à tout ce qui fait l’intérêt des Jeux. Que ce soit Sotchi en 2014, Rio de Janeiro en 2016, PyeongChang en 2018 ou Tokyo en 2020, toutes créeront une expérience unique pour les spectateurs et les athlètes, et viseront l’excellence tant dans le fonctionnement que pour les sites des Jeux. Chaque ville hôte prévoit un héritage des Jeux différent. La Russie accueillera pour la première fois une édition d’hiver et Sotchi va contribuer à ce que le plus vaste pays du monde atteigne son objectif. En effet, bien que la Russie soit depuis longtemps une grande nation de sports d’hiver, elle ne disposait pas encore de centre de sports d’hiver de haut niveau. Désormais, grâce aux nouveaux sites sportifs et aux nouvelles infrastructures de transport, la ville de Sotchi, qui était jusqu’à présent une station balnéaire estivale sur les rives de la mer Noire, devient une destination ouverte toute l’année, aussi bien pour les Russes que pour les visiteurs du monde entier. D’autres villes hôtes ont des objectifs moins ambitieux et s’en tiennent à leurs besoins propres et  à leur vision stratégique. La méthode de préparation et d’organisation des Jeux n’est pas à taille unique, hormis la priorité de servir les athlètes avant tout. Les Jeux sont le lieu où les athlètes de différentes cultures, religions, traditions, modes de vie, origines ethniques et langues peuvent trouver l’unité par le biais de leur passion partagée pour le sport. Le CIO considère cette diversité comme un enrichissement et la protège. Je sais ce que c’est que d’être un athlète dans les derniers instants du compte à rebours qui précède les Jeux. Cela fait quelques années déjà que j’ai concouru mais je n’oublierai jamais mon enthousiasme avant les Jeux de 1976 à Montréal. Je n’aurais jamais imaginé qu’il m’arriverait de compter les jours qui me séparent de mes premiers Jeux en tant que président du CIO. Nous attendons tous l’ouverture des Jeux, le 7 février 2014, avec l’assurance que Sotchi offrira un cadre spectaculaire aux meilleurs athlètes du monde pour qu’ils y surprennent toute la planète, suscitent son admiration et soient une source d’inspiration. ■  REVUE OLYMPIQUE 7"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "INSTANTANÉ  21/07/2013 NATATION SYNCHRONISÉE  Ci-contre, les Japonaises Yumi Adachi et Yukiko Inui lors de la série préliminaire de l’épreuve technique en duo de natation synchronisée, au deuxième jour des 15es Championnats du monde de la FINA à Barcelone, Espagne. Le duo a terminé cinquième de cette épreuve remportée par les Russes Svetlana Kolesnichenko et Svetlana Romashina. Photo: Clive Rose/ Getty Images"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "INSTANTANÉ  18/08/2013 ATHLÉTISME  Le Français Gaëtan Saku Bafuanga Baya s’élance lors de la finale du triple saut aux Championnats du monde de l’IAAF à Moscou. Avec son saut à 16,79 m, il s’est classé septième tandis que son compatriote, Teddy Tamgho, a décroché la médaille d’or en atteignant 18,04 m. Photo: /Getty Images"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "TOKYO SERA L’HÔTE DES JEUX DE 2020  THOMAS BACH EST ÉLU PRÉSIDENT DU CIO  Réuni pour sa 125e Session à Buenos Aires, le CIO a confié l’organisation des Jeux de la XXXIIe Olympiade en 2020 à Tokyo, laquelle l’a emporté sur les deux autres villes en lice, Istanbul et Madrid, après deux tours de scrutin. Tokyo a obtenu 60 voix contre 36 pour Istanbul après une égalité au premier tour entre Madrid et Istanbul. Tokyo, qui était également candidate pour l’édition de 2016, a déjà accueilli les Jeux en 1964. «Félicitations à Tokyo pour son élection en tant que ville hôte des Jeux Olympiques en 2020», a déclaré Jacques Rogge, devenu président honoraire du CIO depuis le 10 septembre, après 12 années de mandat. «Dès le départ, Tokyo a présenté une solide candidature sur le plan technique, et il le fallait face aux dossiers d’Istanbul et de Madrid. Les trois villes auraient toutes été capables d’organiser d’excellents Jeux mais c’est finalement l’invitation de Tokyo à “découvrir demain” qui a le plus séduit les membres du CIO. L’engagement des organisateurs japonais à livrer des Jeux bien organisés et sûrs renforcera les valeurs olympiques tout en démontrant les bienfaits du sport à la nouvelle génération.»  L’Allemand Thomas Bach est devenu le neuvième président du Comité International Olympique (CIO). Il a été élu après deux tours de scrutin par la 125e Session du CIO réunie à Buenos Aires, Argentine, en septembre dernier. Thomas Bach s’est imposé face aux autres candidats à la présidence, à savoir Sergey Bubka (Ukraine), Richard Carrión (Porto Rico), Ser Miang Ng (Singapour), Denis Oswald (Suisse) et ChingKuo Wu (Chinese Taipei). Il a confié après son élection: «Je souhaiterais tout d’abord remercier du fond de mon cœur tous mes amis et collègues qui ont voté pour moi ce matin. C’est pour moi une preuve incontestable de votre confiance. Je tiens également à remercier les autres candidats, pour qui j’ai le plus profond respect, et tous ceux qui n’ont pas voté pour moi cette fois. Je travaillerai avec vous et pour vous dans les années qui viennent, et veux gagner votre confiance. Je connais les responsabilités qu’implique la fonction de président du CIO. Cela me rend humble. Je veux diriger le CIO selon ma devise “l’unité dans la diversité”. Je veux être votre président à tous. Aussi ferai-je tout ce qui est en mon pouvoir pour concilier les  différents intérêts des partenaires du Mouvement olympique. C’est la raison pour laquelle je veux vous écouter et dialoguer avec vous. Sachez que ma porte, mes oreilles et mon cœur vous seront toujours ouverts.» Le nouveau président succède à Jacques Rogge, dont le mandat de 12 ans à la tête du  CIO s’est achevé officiellement à la fin de la 125e Session du CIO. Le président est élu par les membres du CIO à bulletins secrets pour un mandat de huit ans, renouvelable une fois pour quatre ans. Ci-dessus: le président Thomas Bach à Buenos Aires.  ÉLECTION À LA COMMISSION EXÉCUTIVE Lors de la 125 e Session du CIO, Anita L. DeFrantz (États-Unis d’Amérique) a été élue pour succéder à John Coates (Australie) qui a lui-même été élu vice-président en  remplacement de Ser Miang Ng (Singapour), dont le mandat expirait. La commission exécutive (CE) du CIO est composée du président du CIO, de  quatre vice-présidents et de dix membres. Les membres de la CE sont élus par la Session, à bulletins secrets, pour un mandat de quatre ans.  REVUE OLYMPIQUE 13"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "NOUVEAUX MEMBRES DU CIO Neuf nouveaux membres du CIO ont été élus lors de la 125e Session: Octavian Morariu, Roumanie; Bernard Rajzman, Brésil; Mikaela Maria Antonia Cojuangco-Jaworski, Philippines; Alexander Zhukov, Fédération de Russie; Paul Kibii Tergat, Kenya; Lawrence Probst III, États-Unis; Dagmawit Girmay Berhane, Éthiopie, Camiel Eurlings, Pays-Bas; Stefan Holm, Suède. Ci-dessous: les neuf nouveaux membres du CIO.  NOUVEAUX MEMBRES HONORAIRES DU CIO Kevan Gosper et Lamine Diack, dont les mandats de membre du CIO s’achèvent fin 2013 du fait de la limite d’âge, deviendront membres honoraires à la fin de l’année. Tous deux ont été membres du CIO pendant plus de dix ans. Kevan Gosper a également reçu l’ordre olympique qui avait déjà été décerné à Lamine Diack en 1990.  14 REVUE OLYMPIQUE  EN BREF Journée internationale du sport au service du développement et de la paix L’Assemblée générale de l’ONU a approuvé par consensus la création d’une Journée internationale du sport au service du développement et de la paix. Elle sera fêtée par les États membres de l’ONU et des organisations partenaires le 6 avril de chaque année, jour de l’ouverture des premiers Jeux Olympiques de l’ère moderne à Athènes en 1896. Le rôle joué par le CIO dans la société a aussi été rappelé, qu’il s’agisse de favoriser des modes de vie sains ou de mettre le sport à la portée du plus grand nombre. Droits de diffusion en Asie Le CIO a attribué à Dentsu Inc. les droits de diffusion dans 17 pays d’Asie pour Sotchi 2014, Rio 2016 et Nanjing 2014. Dentsu va maintenant chercher des partenaires de diffusion pour toutes les plateformes.  LA LUTTE FÊTE SON MAINTIEN AU PROGRAMME OLYMPIQUE La lutte a été retenue comme sport additionnel pour le programme des Jeux Olympiques d’été de 2020 et 2024. La décision a été prise lors de la 125e Session à Buenos Aires par les membres du CIO, qui avaient au préalable défini les 25 sports qui constitueront le noyau de sports principaux pour les Jeux de 2020. La Fédération Internationale des Luttes Associées (FILA), la Confédération mondiale de baseball et softball (WBSC) et la Fédération mondiale de squash (WSF), toutes trois sélectionnées en mai dernier par la commission exécutive du CIO après un examen mené par la commission du pro-  gramme olympique, ont fait une présentation à la Session. La lutte a obtenu la majorité des votes au premier tour de scrutin. «Je tiens à adresser mes félicitations à la FILA, a déclaré le président d’alors Jacques Rogge. La lutte a fait preuve d’une formidable passion et d’une volonté inébranlable.»  NEUF CANDIDATS AUX ÉLECTIONS À LA COMMISSION DES ATHLÈTES La commission exécutive du CIO a approuvé les candidatures de neuf athlètes pour les élections à la commission des athlètes du CIO qui auront lieu durant les Jeux Olympiques d’hiver à Sotchi, Russie, en février 2014. Deux sièges seront à pourvoir, les mandats des membres Beckie Scott et Saku Koivu s’achevant l’hiver prochain. Tous les concurrents des Jeux à Sotchi Nom M. M. M. Mme Mme M. Mme Mme  ALBRECHT BJØRNDALEN CUCHE DOMRACHEVA JELUŠIC´ PILLER-COTTRER POUTIAINEN STRACHOVÁ ´ ´ (née ZAHROBSKA) Mme WICKENHEISER  pourront voter. Après approbation par la Session du CIO, les deux élus deviendront membres du CIO pour une durée de huit ans. Parmi les candidats (cités dans l’ordre alphabétique) figurent des grands noms des sports d’hiver. Tous ont à cœur de s’acquitter de cette importante mission qu’est la représentation des athlètes olympiques.  Prénom  CNO  Sport  Kilian Ole Einar Didier Darya Ana Pietro Tanja ˇ´ Sarka  BUL NOR SUI BLR CRO ITA FIN CZE  Ski alpin Biathlon Ski alpin Biathlon Ski alpin Ski de fond Ski alpin Ski alpin  Hayley  CAN  Hockey sur glace"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "TRENTE-TROISIÈME ÉDITION DE LA SEMAINE OLYMPIQUE À LAUSANNE Organisée par Le Musée Olympique au mois d’octobre, la Semaine olympique a permis à plus de 3 000 jeunes de 9 à 15 ans de tester gratuitement de nombreuses disciplines sportives sur les quais d’Ouchy, à Lausanne, Suisse. Une trentaine de clubs sportifs et près de 300 moniteurs et bénévoles étaient à pied d’œuvre pendant cette semaine de vacances scolaires pour offrir aux enfants l’occasion de s’initier à de nombreux sports tels que l’athlétisme, l’aviron, le bobsleigh, le judo, l’escrime, le handball ou le tir à l’arc. Cette année, le roller hockey en ligne s’est ajouté au programme. Le Musée Olympique préparant sa réouverture pour le mois de décembre, c’est donc toujours sur l’Helvétie, le bateau qui abritait le musée éphémère qu’a eu lieu la traditionnelle rencontre avec des athlètes. Cette année, il s’agissait de la nageuse australienne Sophie  Edington et de la patineuse artistique américaine Emily Hughes. La première a participé aux Jeux Olympiques de 2008 à Beijing et a gagné plusieurs médailles aux championnats du monde. La seconde a participé aux Jeux Olympiques d’hiver de 2006 à Turin et plusieurs fois aux championnats du monde. Toutes  deux ont partagé leurs expériences avec plus de 70 jeunes. Depuis sa première édition au début des années 1980, la Semaine olympique est organisée par Le Musée Olympique, chaque année au mois d’octobre. Elle a pour but la promotion des valeurs olympiques, l’éducation et l’épanouissement grâce au sport. Au fil des ans, la Semaine olympique a permis de susciter des vocations sportives chez les jeunes. Cet événement gratuit est possible grâce à l’engagement des quelque 150 moniteurs des clubs sportifs de la région et à l’enthousiasme des 150 fidèles bénévoles chargés de l’accueil.  RÉOUVERTURE DU MUSÉE Le Musée Olympique rouvrira ses portes au mois de décembre. Fermé temporairement en janvier 2012, le musée a été entièrement transformé pour laisser la place à de nouveaux et plus grands espaces d’exposition et d’accueil. Le parc qui l’environne a lui aussi été repensé. L’exposition permanente est maintenant disposée sur trois niveaux. Chacun d’entre eux est dédié à une dimension essentielle de l’Olympisme moderne: tout d’abord, son influence dans le monde et dans la société, puis les Jeux Olympiques eux-mêmes et enfin, les athlètes et l’esprit olympique. Sur plus de 3 000 m2, cet espace fait appel à des techniques de présentation et à une muséographie ultra-modernes qui mettent l’accent sur l’interactivité et les images. Plus de 300 écrans et 1 000 objets raconteront l’histoire de grands champions, de concurrents moins connus et de créateurs et volontaires qui, ensemble, à l’occasion des Jeux Olympiques, ont offert au monde un événement extraordinaire. Deux salles seront consacrées aux expositions temporaires et deux nouvelles pièces ont été équipées d’une technologie de pointe dans le domaine de l’éducation. Ceci permettra à plus de 25 000 personnes chaque année de découvrir ce qui se cache derrière les Jeux et ce que l’on peut apprendre des champions olympiques tout en se divertissant.  Ci-dessus et à gauche: plus de 3 000 jeunes ont fait du sport et rencontré des athlètes olympiques.  REVUE OLYMPIQUE 15"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "LE NOUVEAU SPOT TV DU CIO ATTISE L’INSPIRATION  LE CIO CRÉE UNE NOUVELLE APPLICATION  Le nouveau spot TV du CIO illustre la dynamique humaine du Mouvement olympique. Intitulé «Inspiration sans frontières», ce spot met en scène des extraits d’archives olympiques avec des images d’enfants pratiquant un sport, soulignant ainsi les liens qui s’établissent entre les athlètes olympiques et les jeunes pour qui ils sont une source d’inspiration. Proposé aux diffuseurs partenaires olympiques du monde entier dans le cadre de  Le CIO a lancé l’application Olympic Athletes’ Hub qui permet d’accéder, pour la première fois sur des smartphones, aux activités des olympiens sur les réseaux sociaux. Le Hub regroupe non seulement tous les contenus publiés sur Facebook et Twitter mais aussi sur Instagram, réseau de partage de photos et vidéos en ligne. Les fans d’Olympisme peuvent ainsi communiquer avec les olympiens sur le web (via leurs téléphones mobiles et ordinateurs) ou sur l’app’ via leurs smartphones. Quant aux athlètes, ils peuvent communiquer entre eux et directement avec le CIO. «La nouvelle application et les mises à jour sont le dernier exemple en date des efforts permanents déployés par le CIO pour relier les athlètes à leurs fans», a dit Claudia Bokel, médaillée olympique d’argent en escrime et présidente de la commission des athlètes du CIO. «Le Hub est un outil qui nous permet à nous les athlètes de dialoguer avec le public et entre nous. Ces nouveautés nous facilitent la communication de manière novatrice.» En activant la fonction recherche, les utilisateurs peuvent trouver les athlètes par pays, équipe, sport ou édition des Jeux. Plus de 5 000 olympiens ont d’ores et déjà rejoint le Hub.  leur promotion et couverture des Jeux à Sotchi en 2014, ce spot démontre que l’intérêt pour les Jeux d’hiver ne se limite pas aux pays septentrionaux ou qui connaissent la neige et la glace. En réalité, ils sont partout une source d’inspiration pour la jeunesse. «Ce spot démontre que les Jeux Olympiques inspirent et déclenchent l’enthousiasme des gens de tous les coins du monde», a déclaré Timo Lumme,  directeur exécutif des services de télévision et de marketing du CIO. «Il donne à voir des lieux de tous les jours, où de futurs olympiens imitent les pratiques et les techniques de leurs héros olympiques de manière très créative. C’est un film qui montre que l’énergie et l’esprit des Jeux ne connaissent pas de frontières.» Ci-dessous: le spot TV démontre l’attrait mondial des sports d’hiver.  CONFÉRENCE SUR L’ENVIRONNEMENT À SOTCHI À la fin de la 10e Conférence mondiale sur le sport et l’environnement, début novembre, plus de 500 participants ont adopté la «Déclaration de Sotchi». C’est un ensemble de recommandations sur le développement durable qui s’adressent aux différentes parties prenantes de ce domaine. Parmi ces recommandations figure le renforcement des exigences  16 REVUE OLYMPIQUE  lors de la procédure de candidature à l’organisation des Jeux Olympiques. Le but est de s’assurer qu’elles soient parfaitement intégrées dans les systèmes et structures liés à l’organisation et à la tenue des Jeux. La Conférence était organisée à Sotchi par le CIO en partenariat avec le gouvernement et le ministère des Ressources naturelles et de l’Environnement russes, le  Programme des Nations Unies pour l’environnement (PNUE) et avec le soutien du Comité Olympique russe et du comité d’organisation de Sotchi 2014. Sur le thème «Changer le présent pour un avenir meilleur», des présentations ont été données en séances plénières et parallèles. Les participants ont pris part à des débats approfondis dans un esprit de coopération et d’amitié."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "LA FLAMME OLYMPIQUE EST ALLUMÉE ET LE RELAIS DE LA FLAMME COMMENCE La flamme olympique a été allumée le 29 septembre dans l’Ancienne Olympie, Grèce, donnant ainsi le coup d’envoi symbolique du relais de la flamme. Le relais s’étendra sur plus de 65 000 km, traversant les 83 régions de Russie et passera à moins d’une heure de 90 % de la population russe avant d’atteindre le stade olympique de Sotchi le 7 février prochain pour la cérémonie d’ouverture des Jeux.  «Ainsi, le relais de la flamme olympique diffusera, au cours des prochains mois, les valeurs olympiques d’excellence, d’amitié et de respect, sans aucune discrimination, à des hommes et des femmes de tous les milieux», a déclaré le président du CIO, Thomas Bach. Ci-dessous: l’allumage de la flamme olympique dans l’Ancienne Olympie.  EN BREF Développement durable à Rio de Janeiro Le comité d’organisation des Jeux Olympiques à Rio en 2016 (Rio 2016) a lancé son plan de gestion de la durabilité dans le respect de ses objectifs. Le plan vise à définir les bases de l’action et à intégrer les principes et projets relatifs à la durabilité dans l’organisation des grandes manifestations mondiales. La planète, les gens et la prospérité, tels sont les fondements de ce plan mis en œuvre par le gouvernement fédéral, l’État de Rio et la municipalité. Un accord de coopération technique avec le Programme des Nations Unies pour l’environnement (PNUE) prévoit une évaluation et facilitera le dialogue entre Rio 2016 et le peuple du Brésil. S’exprimant lors du lancement, Carlos Nuzman, président de Rio 2016, a souligné le rôle important que le sport joue dans la promotion d’un monde respectueux de l’environnement.  COMMISSION DE COORDINATION À RIO DE JANEIRO  Ci-dessus Nawal El Moutawakel, présidente de la commission de coordination, à Rio de Janeiro. Clôturant sa cinquième visite, la commission de coordination du CIO des Jeux Olympiques de 2016 à Rio de Janeiro a souligné les grands progrès accomplis. À moins de trois ans des Jeux, le comité d’organisation et ses partenaires gouvernementaux ont pu démontrer que la planification et la livraison de l’héritage durable des Jeux étaient en bonne voie. De solides progrès ont été réalisés dans d’autres secteurs tels que la modélisation des sites, la préparation des épreuves tests, l’hébergement, la durabilité, l’expérience des spectateurs et le marketing. À l’issue de la réunion, la présidente de la commission du CIO, Nawal El Moutawakel, a déclaré: «Vingt-neuf semaines après notre dernière visite à Rio de Janeiro, nous avons pu voir les progrès accomplis dans un certain nombre de domaines et constater que les organisateurs et leurs partenaires ont bien compris quels sont les secteurs à développer en priorité.»  REVUE OLYMPIQUE 17"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "CONCOURS DE CRÉATION DES MÉDAILLES DE NANJING 2014  MICHELLE WIE, AMBASSADRICE DES JOJ  Le CIO a ouvert un concours aux fans et aux jeunes créateurs, leur permettant d’écrire une page de l’histoire olympique en concevant les médailles des JOJ de 2014 à Nanjing. Les propositions peuvent être postées jusqu’au 30 novembre 2013 sur le site www. medaldesigncompetition.com. Le jury du CIO se compose notamment de l’artiste renommé Thomas Heatherwick et de grands noms du sport tels que la championne olympique de  Michelle Wie, âgée de 24 ans, devient ambassadrice des JOJ. La golfeuse américaine fera profiter les premiers golfeurs des JOJ de ses conseils et de son expérience tout en invitant les jeunes du monde à être sportifs et à partager les valeurs olympiques. À cette occasion, Michelle a déclaré: «Je suis très honorée de participer aux JOJ. J’espère apprendre aux jeunes à s’amuser en pratiquant leur sport, à être des compétiteurs, à se battre pour ce qu’ils désirent et à comprendre l’importance d’avoir un rêve. C’est important de motiver les jeunes, tout comme d’être actif et d’être à l’extérieur. Enfant, je jouais à différents sports et passais peu de temps à l’intérieur.» Le golf deviendra pour la première fois sport olympique à Nanjing en 2014.  patinage de vitesse sur piste courte, Yang Yang, ou encore la championne du 400 m haies des JOJ de 2010 à Singapour, Aurélie Chaboudez. Il sélectionnera en décembre le vainqueur ainsi que deux autres gagnants. Le modèle retenu figurera sur les médailles d’or, d’argent et de bronze des JOJ à Nanjing, du 16 au 28 août 2014. Le vainqueur gagnera un voyage à ces JOJ, des billets pour la cérémonie d’ouverture ainsi  qu’une collection de médailles figurant sa création. Ci-dessus: de jeunes athlètes arborant la médaille des JOJ de 2010.  CHAD LE CLOS, AMBASSADEUR DES JOJ Le CIO a annoncé que Chad Le Clos serait l’un des ambassadeurs des JOJ de 2014 à Nanjing. Le nageur sud-africain est quintuple médaillé des tout premiers JOJ en 2010 à Singapour et médaillé d’or du 200 m papillon des JO de 2012 à Londres. Il conseillera et partagera son expérience avec les jeunes athlètes des JOJ mais aussi, engagera les jeunes du monde entier à s’impliquer dans le sport et à adhérer aux valeurs olympiques. «Les JOJ ont été un formidable tremplin. Ils m’ont beaucoup aidé, notamment à faire face à la pression de ma première participation aux Jeux Olympiques à Londres. Mais au-delà du sport, les souvenirs et les amis que je m’y suis faits dureront pour toujours et j’ai hâte de vivre à nouveau cette expérience!»  18 REVUE OLYMPIQUE  Ci-contre: Chad Le Clos, champion olympique de natation, a remporté cinq médailles aux JOJ de 2010."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "LITUANIE: NOUVELLE COMMISSION SPORT ET FEMME Le CNO lituanien a créé une commission sport et femme, que préside Daina Gudzinevičiūtė, actuelle présidente du CNO. Les autres membres sont: la lauréate du trophée 2013 du CIO Femme et Sport, Ona Baboniene; les conférencières d’université, Irena Čikotienė, Nelė Žilinskienė et Ramunė Žilinskienė; les parlementaires, Aušrinė Marija Pavilionienė et Dalia Teišerskytė; les secrétaires générales de l’Union des fédérations sportives  et de l’Union lituanienne du tir sportif, Agnė Vanagienė and Vaida Masalskytė. L’objectif est de renforcer le rôle des femmes dans le sport, de les soutenir lorsqu’elles postulent à des postes à responsabilité au sein d’organisations sportives, et d’accroître la promotion des athlètes féminines dans la société. À gauche: Daina Gudzinevičiūtė, présidente de la commission.  EXPOSITION OLYMPIQUE AU MUSÉE DE RIO Rio de Janeiro, ville hôte des Jeux Olympiques de 2016, a accueilli l’exposition «Jeux Olympiques: Sport, Culture et Art». Organisée par le CNO brésilien et hébergée au Musée d’histoire nationale, cette exposition gratuite rassemblait près de 300 objets racontant l’histoire des Jeux de l’ère moderne, dont des médailles, torches, mascottes et uniformes qui font  partie de la collection du Musée Olympique à Lausanne. Les visiteurs ont pu porter la torche des Jeux de 2012, prendre des photos avec Mischa, la mascotte des Jeux de 1980 ou simuler un saut en longueur. Dans une salle attenante étaient projetées des vidéos de la collection du CIO. Et des objets ayant appartenus à des champions olympiques tels que  RÉÉLECTION DU PRÉSIDENT DE L’IJF Marius Vizer (en photo), président de la Fédération Internationale de Judo (IJF), a été réélu pour quatre ans lors du Congrès qui s’est tenu à Rio de Janeiro. D’autre part, l’IJF a inauguré son académie et son premier projet, le programme  de qualification des entraîneurs, qui a été présenté aux délégations participant aux Championnats du monde. L’académie apportera aussi son soutien professionnel et éducatif aux fédérations nationales.  la star de tennis suisse Roger Federer, le joueur de basketball américain Michael Jordan et le nageur brésilien César Cielo étaient aussi exposés. «C’est un honneur de réunir à Rio de Janeiro des objets ayant témoigné de moments importants dans l’histoire moderne», a déclaré Christiane Paquelet, directrice culturelle du CNO brésilien.  NOUVEAU PRÉSIDENT À LA FISA Lors de leur Congrès ordinaire à Chungju (République de Corée), les fédérations membres de la Fédération Internationale des Sociétés d’Aviron (FISA) ont élu leur nouveau président, le Français Jean-Christophe Rolland (ci-dessous, à g.). Il entrera en fonction en juillet 2014, succédant à Denis Oswald, membre du CIO, qui avait été reconduit pour une période intérimaire. Jean-Christophe Rolland a participé trois fois aux Jeux, remportant le bronze à Atlanta en 1996 et l’or à Sydney en 2000. Il détient deux titres et trois autres podiums mondiaux. Au sein de la FISA, il a été président de la commission des athlètes de 2002 à 2011 et a siégé au comité exécutif de 2004 à 2011. La Canadienne Tricia Smith a été élue la vice-présidente de la FISA.  RÉÉLECTION DU PRÉSIDENT DE LA FINA Julio César Maglione (ci-dessus, à droite) a été réélu à la présidence de la Fédération Internationale de Natation (FINA). Réuni à Barcelone, le Congrès de la FINA a rassemblé des délégués de 170 fédérations nationales (un record). Le Congrès a élu un nouveau bureau pour la période 2013 – 2017 et a apporté des modifications dans le règlement en approuvant notamment la création d’un comité d’éthique de la FINA.  REVUE OLYMPIQUE 19"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "L’UCI A UN NOUVEAU PRÉSIDENT Président de British Cycling, Brian Cookson a été élu à la présidence de l’Union Cycliste Internationale (UCI) lors de son Congrès annuel à Florence, Italie, dans le cadre des Championnats du monde sur route. S’exprimant après son élection, Brian Cookson a déclaré: «Je souhaite vous remercier pour la confiance que vous m’avez témoignée aujourd’hui. Le vrai travail commence maintenant.»  WORLD ARCHERY RÉÉLIT SON PRÉSIDENT Le membre du CIO Ugur Erdener était l’unique candidat à sa réélection au poste de président de World Archery. Il a été réélu lors du 50e Congrès qui a eu lieu à Belek, Turquie, avec 93 voix pour et 2 voix contre. Ugur Erdener a été élu pour la première fois en 2005. Il a succédé à l’Américain James Easton, puis a été réélu en 2009.  LE PRÉSIDENT DE L’IHF A ÉTÉ RÉÉLU  LISTE DES INTERDICTIONS DE L’AMA  Lors de son Congrès tenu à Doha, Qatar, la Fédération Internationale de Handball (IHF) a reconduit à sa présidence Hassan Moustafa. Il a été élu en tant que candidat unique pour un quatrième mandat avec plus de 90 % des voix. Sa priorité sera de continuer à mondialiser le handball. Le 1er vice-président, Miguel Roca Mas et le trésorier, Sandi Solal, continueront aussi d’exercer leurs fonctions pendant les quatre prochaines années. L’IHF a aussi annoncé que le Japon accueillera l’édition féminine des Championnats du monde de 2019 tandis que le Danemark et l’Allemagne organiseront conjointement l’édition masculine.  L’Agence Mondiale Antidopage (AMA) a publié la liste des substances interdites en 2014, après qu’elle a été approuvée par son comité exécutif en septembre dernier. Dans le souci de fournir aux parties prenantes des outils permettant de lutter contre le dopage, cette liste sera à nouveau disponible sur les appareils mobiles dès qu’elle prendra effet, le 1er janvier 2014. Elle est aussi accessible sur www.wada-ama.org  Ci-dessus: le président de l’IHF, Hassan Moustafa, à Doha.  QUI LIT LA REVUE OLYMPIQUE?  Qui: les haltérophiles chinois, Lu Xiaojun (à g.) – champion olympique et du monde, et Liao Hui (à dr.) lisent la Revue Olympique avec leur entraîneur, Yu Jie, après de nouveaux records. Où: aux Championnats du monde de l’IWF de 2013 à Wroclaw, Pologne.  20 REVUE OLYMPIQUE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "L’IJF ÉLIT LE PRÉSIDENT DE SA COMMISSION DES ATHLÈTES Sextuple champion du monde, le Français Teddy Riner a été élu président de la commission des athlètes de la Fédération Internationale de Judo (IJF). Champion olympique en 2012, il succède au Japonais Hirotaka Okada, médaillé de bronze aux Jeux de 1992 et double champion du monde. Ce dernier avait été élu en 2009 lors de la création de la commission. À gauche: Teddy Riner savoure sa victoire dans l’épreuve des poids lourds aux Jeux de 2012.  LA COMMISSION DES ATHLÈTES DE LA FIE S’AGRANDIT Six nouveaux membres ont été élus par leurs pairs à la commission des athlètes de la Fédération Internationale  22 REVUE OLYMPIQUE  d’Escrime (FIE) lors des Championnats du monde d’escrime 2013 à Budapest, Hongrie. Un total record de 724 athlètes ont participé au vote parmi les 19 candidats en lice. Parmi les élus, citons: Yuki Ota (JPN), Mariel Zagunis (USA), Valentina Vezzali (ITA), Áron Szilágyi (HUN), Ana Maria Brânză (ROU), et Nikolay Kovalev (RUS). La FIE a également annoncé le lancement d’un programme de suivi de carrière des athlètes pour 2014, lequel a été conçu afin de préparer les escrimeurs pour leur reconversion professionnelle.  ˇ VERA CÁSLAVSKÁ OFFRE DEUX DE SES MÉDAILLES La légende tchèque de la gymnastique artistique, Vera Čáslavská a eu un geste symbolique à l’égard de la Slovaquie qui faisait partie – jusqu’à son indépendance en 1993 – de la Tchécoslovaquie, sa patrie. La championne aux 11 médailles olympiques a offert deux de ses sept médailles d’or (une de Tokyo 1964 et une de Mexico 1968) au Musée slovaque de la culture physique, en signe de cadeau à toute la Slovaquie. La cérémonie a eu lieu le 13 septembre à Bratislava dans le cadre de l’exposition «Victoires et défaites: le sport slovaque de 1993 à 2012». Vera Čáslavská, qui fut membre du CIO, a été présidente du CNO tchécoslovaque de 1990 à 1992 puis du CNO tchèque (jusqu’en 1996) après le partage de la Tchécoslovaquie. À droite: Vera Čáslavská remet deux de ses médailles d’or.  ÉLECTION À LA COMMISSION DES ATHLÈTES DE LA FILA  Carol Huynh, championne olympique canadienne, a été élue présidente de la toute nouvelle commission des athlètes de la Fédération Internationale des Luttes Associées (FILA). La jeune femme de 33 ans, championne olympique de la catégorie des 48 kg en lutte libre aux Jeux de 2008 Beijing et médaillée de bronze des Jeux de 2012 à Londres,  représentera dorénavant les athlètes au sein du bureau de la FILA. «Je suis très honorée d’avoir été choisie par mes pairs, a-t-elle déclaré. C’est une grande responsabilité de s’assurer que la voix des athlètes est bien entendue. Je souhaite développer un environnement au sein de notre grande communauté, dans lequel les athlètes puissent s’impliquer activement et s’intéresser au fonctionnement de notre sport.» La commission des athlètes comprend aussi Maria Prevolaraki (GRE); Jake Herbert (USA); Kaori Icho (JPN); Christophe Guénot (FRA); Hamid Soryan Reihanpour (IRI) et Tamás Lörincz (HUN)."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "LE PRÉSIDENT DU CIO  PRENDRE LE RELAIS SUITE À SON ÉLECTION LORS DE LA 125E SESSION DU CIO À BUENOS AIRES, L’ALLEMAND THOMAS BACH A SUCCÉDÉ À JACQUES ROGGE EN DEVENANT LE NEUVIÈME PRÉSIDENT DU COMITÉ INTERNATIONAL OLYMPIQUE. GÜNTER DEISTER DRESSE ICI LE PORTRAIT DU NOUVEAU CHEF DU MOUVEMENT OLYMPIQUE.  24 REVUE OLYMPIQUE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "LE PRÉSIDENT DU CIO  C À gauche: Thomas Bach est le premier médaillé d’or olympique au fleuret en équipe à être nommé président du CIO. Ci-dessous: Thomas Bach est accueilli en héros dans son pays après avoir décroché l’or au fleuret en équipe aux Jeux Olympiques de 1976.  ’est une journée particulière de 1980 qui devait constituer un tournant dans la vie de Thomas Bach et qui a beaucoup contribué à donner sa forme à un parcours qui vient de connaître son apogée avec son élection à la présidence du Comité International Olympique (CIO). Ce jourlà, Thomas Bach, alors âgé de 26 ans, tente avec une délégation d’athlètes d’Allemagne de l’Ouest, de persuader le chancelier Helmut Schmidt de ne pas se joindre au boycott des Jeux Olympiques à Moscou. Le chancelier rejette la demande du fait de la solidarité impérative du pays avec les États-Unis, leurs alliés de l’OTAN, sur laquelle le sport doit s’aligner. D’autres pays d’Europe de l’Ouest iront aux Jeux à Moscou et le chancelier Schmidt, homme d’état hautement respecté, a depuis concédé que le boycott avait été une erreur. Pour sa part, Thomas Bach a été profondément influencé par cette rencontre. Sa détermination à soutenir la cause des athlètes et sa conviction que le sport international et le Mouvement olympique ne peuvent s’épanouir que s’ils ne sont pas l’instrument des politiques n’en ont été que renforcées. «Le sport doit demeurer indépendant de la politique, tout en restant conscient que ses décisions ont des conséquences politiques», admet-il.  Telle est la conviction qu’il a tirée de son entrevue avec le chancelier Schmidt et qu’il apporte avec lui dans ses nouvelles fonctions de président du CIO. Thomas Bach a grandi dans la petite ville franconienne de Tauberbischofsheim. À l’origine, il voulait être footballeur mais au lieu de cela, il devient escrimeur de première classe, spécialiste du fleuret. Il le doit au centre d’escrime de sa ville, à la renommée internationale. Ses exploits internationaux le transforment en coéquipier accompli. Aux Jeux Olympiques de 1976 à Montréal, il aide l’équipe allemande à s’assurer la médaille d’or en fleuret. Avec ses coéquipiers, il décroche également le Championnat du monde et conserve ce titre l’année suivante. Tout en poursuivant sa carrière sportive, Thomas Bach étudie le droit et les sciences politiques et, en 1983, il obtient son diplôme avec mention bien. À cette époque déjà, il se fait un nom en tant que porte-parole de ses camarades athlètes ouest-allemands, rôle qui va perdurer au sein du CIO. Sur la scène olympique, Thomas Bach pose ses marques en premier lieu à Baden-Baden, célèbre ville thermale allemande où a lieu le Congrès olympique de 1981. Avec son ami, le champion olympique britannique Sebastian Coe, il mène les athlètes invités par Juan Antonio Samaranch, alors président du CIO. Ses éloquentes contributions font grosse ➤  TOUT EN POURSUIVANT SA CARRIÈRE SPORTIVE, THOMAS BACH ÉTUDIE LE DROIT ET LES SCIENCES POLITIQUES ET, EN 1983, IL OBTIENT SON DIPLÔME AVEC MENTION BIEN. À CETTE ÉPOQUE DÉJÀ, IL SE FAIT UN NOM EN TANT QUE PORTEPAROLE DE SES CAMARADES ATHLÈTES OUEST-ALLEMANDS, RÔLE QUI VA PERDURER AU SEIN DU CIO.  REVUE OLYMPIQUE 25"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "LE PRÉSIDENT DU CIO  impression sur le Congrès, et sa rhétorique est si persuasive qu’il est surnommé «le professeur» (quand Sebastian Coe est qualifié de « Shakespeare »). Selon les deux hommes, les athlètes font des Jeux Olympiques ce qu’ils sont, et pour cette raison ils doivent avoir le droit à une voix et à un vote au sein du CIO. Ils demandent aussi que les athlètes bénéficient d’un plus grand soutien, d’une position résolue dans la lutte contre le dopage qui, avec la politisation, est la plus grande menace à laquelle le sport est confronté. Au nom  Ci-dessus: Thomas Bach (à droite) en pleine action durant sa carrière d’escrimeur. À droite: en porteur de flambeau lors du relais de la flamme olympique à Athènes en 2004.  26 REVUE OLYMPIQUE  des athlètes, ils prônent la suspension à vie pour les infractions de dopage. Cette année-là, Thomas Bach devient membre fondateur de la commission des athlètes, pionnière du genre, voulue par le président Samaranch pour servir de lien entre les athlètes et le CIO. À l’orée du nouveau millénaire, les réformes essentielles qui sont adoptées donnent aujourd’hui aux athlètes 15 voix sur les 115 que compte la Session du CIO. En 1991, à 37 ans, Thomas Bach, dont la carrière d’avocat d’affaires est à présent bien établie, s’embarque dans une nouvelle étape de son itinéraire olympique. Willi Daume, l’organisateur en chef des Jeux Olympiques de 1972 à Munich, cède son siège au CIO à son jeune compatriote. Un an plus tard, Thomas Bach devient membre de la commission du marketing du CIO et entre à la commission juridique l’année suivante avant de prendre en charge, en 1994, les fonctions de président de la chambre d’appel du Tribunal Arbitral du Sport (TAS). La commission d’évaluation"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "LE PRÉSIDENT DU CIO  Ci-dessous: le président du CIO sortant Jacques Rogge (à droite) applaudit son successeur, Thomas Bach (au centre), à la suite de son élection.  pour les Jeux d’hiver de 2002 lui est également confiée en 1995, ainsi que celle pour les Jeux d’été de 2004 à Athènes. En 1996, il est élu pour la première fois à la commission exécutive du CIO. Il en demeurera membre durant 15 ans. Jacques Rogge, qui tient à tirer partie de son expertise, le nomme président de trois des organes essentiels du CIO: les commissions juridique, sport et droit, et de discipline antidopage. L’expérience que Thomas Bach acquiert au service du CIO se révèle précieuse quand, en 2006, il est élu président de la Deutscher Olympischer Sportbund (DOSB) résultant de la fusion de la Deutscher Sportbund (DSB) et du Comité National Olympique (CNO), représentant 28 millions de membres. Le succès de ce processus complexe qu’il a supervisé lui confère une vaste influence qui lui permet de nouer des alliances cruciales dans le monde politique et des affaires. L’expérience et les relations qu’il engrange au niveau national et international de même que les vastes connaissances du sport et du rôle de celui-ci dans la société, lui servent de formidable tremplin en vue de la présidence du CIO. À ce sujet, il a confié qu’il s’était préparé au scrutin du 10 septembre à Buenos Aires «comme un athlète en entraînement intensif», décrivant  la procédure d’élection comme un «grand défi», précisant aussi qu’«un athlète n’a pas l’habitude d’attendre les résultats d’une compétition»! «Quand l’attente a finalement pris fin, le moment a été l’un des plus émouvants de ma vie», a-t-il déclaré, ajoutant qu’il avait même éclipsé le moment où il avait reçu sa médaille d’or. «Je me rappelle à peine la cérémonie protocolaire de 1976. Je n’ai vraiment réalisé toute l’importance de ma victoire que lorsque j’ai vu les 30 000 personnes venus nous acclamer à notre retour.» Thomas Bach veut faire des athlètes sa priorité numéro un. Lui-même et son épouse Claudia se sont installés à Lausanne, Suisse, où il occupe le bureau laissé vacant par Jacques Rogge ainsi que son appartement. Après le passage de témoin d’un président du CIO à l’autre, le Mouvement olympique peut compter sur la continuité. ➤ «L’EXPÉRIENCE ET LES RELATIONS QU’IL ENGRANGE AU NIVEAU NATIONAL ET INTERNATIONAL DE MÊME QUE LES VASTES CONNAISSANCES DU SPORT ET DU RÔLE DE CELUI-CI DANS LA SOCIÉTÉ, LUI SERVENT DE FORMIDABLE TREMPLIN EN VUE DE LA PRÉSIDENCE DU CIO.»  REVUE OLYMPIQUE 27"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "LE PRÉSIDENT DU CIO  La devise de votre candidature était «Unité dans la diversité». Que vouliez-vous dire? Avant tout, cela signifie le respect des différences culturelles, religieuses, des relations sociales, des perceptions et des attitudes. Le secret de la magie des Jeux Olympiques tient dans leur diversité et leur universalité, qui se sont développées depuis plus de 119 ans. Cela mérite d’être protégé et si possible, d’être davantage développé. Cela touche à notre structure et bien entendu, aux Jeux Olympiques eux-mêmes mais aussi à l’éducation, la culture et aux projets sociaux. Et surtout et en premier lieu, cela concerne les athlètes.  THOMAS BACH LE NEUVIÈME PRÉSIDENT DU COMITÉ INTERNATIONAL OLYMPIQUE DÉVOILE SES IDÉES SUR SON NOUVEAU RÔLE, L’AVENIR DES JEUX OLYMPIQUES ET SLA MANIÈRE DE GARDER LES ATHLÈTES AU CŒUR DU MOUVEMENT OLYMPIQUE.  Comment définissez-vous votre rôle? Le président du CIO est comme un chef d’orchestre. Il donne le ton, la cadence et rassemble les membres de sorte que chacun puisse contribuer par ses propres qualités à l’ensemble. Il doit alors réunir ces contributions en une œuvre. Cela demande de la motivation, une capacité à discuter, à se faire confiance et en fin de compte, un consensus.  Les Jeux seront certainement une priorité. Comment comptez-vous maintenir l’équilibre entre tradition et progrès? La durabilité exige d’être plus qu’une expression d’usage. Il ne s’agit donc pas seulement de réduire les coûts, de limiter les charges, d’obtenir une meilleure compatibilité ou une protection de l’environnement plus aboutie. Le critère décisif doit être que les Jeux Olympiques doivent laisser un héritage positif. Si tel n’est pas le résultat, le CIO aura alors échoué dans l’accomplissement de sa mission essentielle. Dans les mois à venir, nous prévoyons de créer un concept complet, depuis le contrat pour les Jeux jusqu’au legs lui-même. En tant que premier champion olympique élu président du CIO, vous avez élevé les attentes concernant l’engagement du CIO à placer les athlètes au cœur du Mouvement olympique. Les athlètes sont la vie même des Jeux et leurs intérêts doivent demeurer la première de nos préoccupations. Ils méritent notre confiance, nos encouragements et bien entendu, notre protection. En échange, nous pouvons attendre d’eux leur engagement sans réserve, leur enthousiasme et l’acceptation des règles. Leurs intérêts doivent être pris en compte plus sérieusement, et ce bien avant le début des Jeux, soit dès la procédure de candidature. Nous devons toujours nous demander «Comment cela affectera-t-il les athlètes?». Aucune décision ne devrait jamais être prise autrement. Vous défendez une politique de tolérance zéro à l’égard du dopage et ce, avant tout, pour protéger les athlètes, en échange de quoi, vous attendez qu’ils respectent les règles. C’est une question d’équité et de respect. Les règles sont clairement fixées et deviennent même plus fermes. La lutte contre le dopage et toutes autres formes de manipulation a pour but de protéger les athlètes qui concourent dans le respect des règles. Les athlètes doivent observer les règles dans leur propre intérêt et respecter leurs adversaires. Le respect va bien au-delà de la tolérance. ■  28 REVUE OLYMPIQUE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "2002  IMAGES OLYMPIQUES CLASSIQUES SALT LAKE CITY SKELETON  Le skeleton n’avait pas figuré au programme des Jeux Olympiques d’hiver depuis 54 ans quand il a été ajouté à celui des Jeux de 2002 à Salt Lake City. C’était aussi la première fois que des compétitions olympiques n’avaient pas lieu à Saint Moritz. Ici, l’Allemande Diana Sartor descend la piste du parc olympique de l’Utah lors d’un entraînement. Elle s’est finalement classée quatrième, à seulement 16 centièmes d’une médaille. L’Américaine Tristan Gale a décroché la médaille d’or. Photo: Getty Images"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOTCHI 2014  Hivernaux. Chaleureux. Pour toi. Sotchi, pittoresque station balnéaire de la mer Noire, offre un contraste naturel entre son front de mer scintillant et les massifs montagneux qui la surplombent. Brian Pinelli témoigne ici de l’enthousiasme qui prend forme en Russie à l’approche des premiers Jeux d’hiver sur le sol russe.  32 REVUE OLYMPIQUE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOTCHI 2014  Ci-dessous: toutes les épreuves de patinage auront lieu dans le complexe côtier de Sotchi au sein du parc olympique.  REVUE OLYMPIQUE 33"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOTCHI 2014  pour l’occasion – abritera pour la première fois tous les sites de compétition de glace, situés à quelques pas les uns des autres. En outre, ces Jeux ouvriront un nouveau chapitre de l’histoire olympique puisqu’ils seront les premiers présidés par Thomas Bach, neuvième président du CIO nouvellement élu. À Sotchi, skieurs, patineurs, glisseurs et snowboardeurs offriront un spectacle éblouissant tout en poussant leurs limites physiques à l’extrême, sur la neige et la glace, durant 17 jours, du 7 au 23 février 2014. Le programme comprend 98 épreuves, dont 12 feront leurs débuts olympiques, dans 7 sports. Plus de 2 500 athlètes de plus de 80 pays y sont attendus. Le complexe côtier de Sotchi comprend cinq arènes construites pour l’occasion,  À Sotchi, skieurs, patineurs, glisseurs et snowboardeurs offriront un spectacle éblouissant tout en poussant leurs limites physiques à l’extrême, sur la neige et la glace, durant 17 jours, du 7 au 23 février.  34 REVUE OLYMPIQUE  L  ’un des aspects fascinants et captivants des Jeux Olympiques c’est qu’aucune édition n’est semblable à l’autre. Chacune se démarque par une atmosphère originale qui incarne l’esprit, la culture, les normes et la géographie du pays et de la région hôtes. Quand le Comité International Olympique (CIO) a attribué l’organisation des XXIIes Jeux Olympiques d’hiver à Sotchi, station balnéaire russe sur les rives paisibles de la mer Noire sertie d’impressionnants massifs montagneux, il s’aventurait en territoire inconnu avec une succession de «premières» en perspective. La Russie accueillera pour la première fois les Jeux d’hiver en 2014. Ces Jeux seront plus compacts que jamais auparavant. En effet, le parc olympique – nommé Complexe côtier et construit  dont le stade olympique «Fisht» de 40 000 places, où auront lieu les cérémonies d’ouverture et de clôture. L’apparence du stade est saisissante! Première installation du genre en Russie, elle est dotée d’une couverture en polycarbonate translucide dont la structure unique permet aux spectateurs de jouir de la vue sur les monts du Caucase au nord et sur la mer Noire au sud. En quelque 40 minutes, grâce à un train express, le spectateur est transposé dans un décor complètement différent, celui des monts du Caucase occidental, où est situé le Complexe de montagne. Tous les sports de neige et ceux de glisse (bobsleigh, luge et skeleton) auront lieu dans cinq installations proches les unes des autres, au-dessus du pittoresque ➤  Ci-dessus (dans le sens des aiguilles d’une montre): Un nouveau Centre alpin a été construit à Rosa Khutor; les nouveaux sites comprennent le Complexe de ski de fond et de biathlon «Laura»; Dmitry Chernyshenko, président du comité d’organisation a supervisé les préparatifs."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOTCHI 2014"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOTCHI 2014  village olympique de Krasnaya Polyana, traversé par la rivière Mzymta. Ces sites, tant du Complexe côtier que de montagne, ont déjà servi à des compétitions de haut niveau, organisées pour beaucoup d’entre elles à l’occasion d’épreuves de la Coupe du monde durant la saison 2012-2013. Ainsi, le comité d’organisation de Sotchi 2014 a pu évaluer son fonctionnement en vue des Jeux à venir. Dmitry Chernyshenko, président-directeur général du comité d’organisation, fait le point sur les derniers préparatifs. «Nous mettons tous nos efforts pour être opérationnels à temps, a-t-il confié. Cela passe d’ailleurs par une formation  36 REVUE OLYMPIQUE  Ci-dessous: le Parc X-treme Rosa Khutor a été l’un des nombreux sites de Sotchi à accueillir les épreuves de la Coupe du monde 2012-2013.  à ce sujet en ce moment. Et nous nous servons de l’expérience gagnée pendant les épreuves tests pour nous assurer que ces premiers Jeux d’hiver en Russie seront vraiment mémorables pour tous ceux qui y seront allés.» En février prochain, tous ces préparatifs deviendront réalité. Le Palais de glace «Bolchoï» sera le témoin d’une effervescence incomparable grâce aux stars de hockey sur glace qui s’y affronteront fiévreusement. Sur place, le public sera en liesse devant la quantité de vedettes nationales comme Alexander Ovechkin, Evgeni Malkin, Ilya Kovalchuk et Pavel Datsyuk. Tous seront  «Nous nous servons de l’expérience gagnée pendant les épreuves tests pour nous assurer que ces premiers Jeux d’hiver en Russie seront vraiment mémorables pour tous ceux qui y seront allés.»"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOTCHI 2014  En photo: le président de Sotchi 2014 Dmitry Chernyshenko (en haut, à gauche) a supervisé une série d’épreuves sportives sur les sites olympiques de Sotchi (ci-dessous).  Ci-contre: des athlètes tels que la Coréenne Yuna Kim magnifieront les sites de Sotchi du 7 au 23 février.  très motivés pour conduire le pays à sa première victoire olympique depuis celle d’Albertville en 1992, décrochée par l’Équipe unifiée, nom de l’équipe nationale après l’éclatement de l’Union soviétique. Ils seront opposés à de redoutables adversaires comme les Canadiens, tenants du titre olympique; les Suédois, champions du monde de 2013; l’équipe américaine, aussi déterminée qu’opportuniste; sans oublier les Finlandais, Tchèques et Slovaques ainsi que l’équipe qui monte, la Suisse. Le patinage artistique, prévu dans le très esthétique Palais des sports de glace «Iceberg », figure parmi les sports les plus  attendus. Les patineurs russes, surtout les couples, auront à cœur de perpétuer la fructueuse histoire et tradition du pays. Pour sa part, le patineur canadien Patrick Chan, triple champion du monde en titre, visera la première médaille d’or olympique masculine de son pays en individuel. Quant à Yuna Kim, de République de Corée, elle défendra son titre olympique dans ce qu’elle a qualifié de son ultime saison de compétition. Autre sport également en vue: le ski alpin qui aura lieu au centre alpin «Rosa Khutor», domaine skiable de classe mondiale qui culmine à 2 320 m dans le massif Rosa. Équipée de systèmes de fabrication de neige les plus onéreux du monde, cette station ➤  REVUE OLYMPIQUE 37"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOTCHI 2014  deviendra la plus grande de Russie. Les skieurs s’élanceront le 9 février lors de l’épreuve-reine de la descente hommes, soit deux jours après la cérémonie d’ouverture. Sélectionnés parmi les meilleurs au monde, ils s’exécuteront à une vitesse sidérante, défiant compétences techniques et endurance sur un tracé de 3 500 m conçu par Bernhard Russi. Doté d’un dénivelé vertigineux de 1 075 m, cette descente poussera les concurrents jusqu’à leurs limites, notamment lors des quatre sauts spectaculaires qui propulseront certains à plus de 50 m. Le dynamique parcours a été testé en avant-première lors de la Coupe du monde de ski alpin en février dernier. Les plus expérimentés comme Bode Miller, quintuple médaillé olympique américain, n’ont pas tari d’éloges. «Le choix de la pente est bon et les sauts sont superbes. Ils sont énormes et présentent de bons angles de réception et de décollage. Je pense que cela en fait une descente naturelle et géniale, a jugé ce  coureur chevronné après sa performance. En fait, une descente doit représenter un défi. Sans les difficultés, vous n’obtenez pas le meilleur des athlètes. Une descente olympique se doit d’être ce qu’il y a de mieux dans le genre!» En ski alpin masculin, Marcel Hirscher, le «wunderkind» autrichien, Aksel Lund Svindal, l’as norvégien, et Ted Ligety, «M. Slalom Géant» américain, devraient mener la course aux médailles. Chez les femmes, la Slovène Tina Maze, détentrice de la Coupe du monde 2012-2013, sort d’une saison stellaire de records. Elle a tout le talent, la polyvalence et la volonté requis pour décrocher une médaille dans quatre  38 REVUE OLYMPIQUE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOTCHI 2014  nuit, sous les projecteurs, sur les six pistes qui se partagent deux aires d’arrivée. «C’est le plus beau parc que j’aie jamais vu, a confié l’Américain Patrick Deneen, champion du monde de bosses. C’est vraiment très, très cool que le parcours de bosses, de half-pipe et de sauts partagent la même aire d’arrivée!» Non loin de cette arrivée, d’autres épreuves attireront les regards comme le slopestyle en ski et en snowboard, où les concurrents exécuteront une série de figures créatives tout en effectuant divers rotations et sauts. Le ski et le snowboard cross regorgeront aussi d’émotions fortes lorsque les coureurs dévaleront la montagne côte à côte, affrontant des courbes relevées, des bosses, des sauts et toute autre surprise du terrain. La Canadienne Kelsey Serwa, vainqueur de l’épreuve test de ski cross l’hiver dernier à Rosa Khutor, a commenté la piste olympique de quelque 1 121 m: «Splendide! Nous skions sur la piste de snowboard qui est très bien. Il y a quelques  En photo: les trois mascottes de Sotchi 2014 seront très présentes durant les Jeux. Les organisateurs ont également prévu de nombreux articles officiels, dont des pièces de monnaie (page de gauche) et des timbres (ci-dessous).  voire cinq épreuves. Mais sa première rivale pourrait bien être l’Américaine Lindsey Vonn, quadruple lauréate du classement général de la Coupe du monde, sous réserve qu’elle confirme sa position dominante après sa blessure au genou dont elle a été victime en février, aux Championnats du monde. Lyndsey tiendra à conserver son titre olympique en descente, le mercredi 12 février. Douze nouvelles épreuves ont été ajoutées au programme olympique dont le half-pipe en ski, le slopestyle en ski et en snowboard, et le slalom parallèle en snowboard sont sûrs d’attirer l’attention des plus jeunes fans! Le 11 février  prochain, les projecteurs se tourneront vers les athlètes féminines qui concourront pour la première fois en saut à ski et s’élanceront du Complexe de tremplins «Russki Gorki». Cette épreuve était réservée aux hommes depuis les 1ers Jeux d’hiver en 1924. Autre première à Sotchi, hommes et femmes concourront ensemble au sein d’une même équipe dans un relais mixte en biathlon, des épreuves de patinage artistique par équipes et un relais par équipes en luge. Le Parc X-treme de Rosa Khutor accueillera les compétitions de ski acrobatique et de snowboard. Huit des vingt épreuves à médailles auront lieu de  sauts énormes et de longues réceptions, ce qui est génial.» «Nous avons minutieusement testé nos infrastructures et sites sportifs ainsi que nos modes de fonctionnement avec les équipes sur le terrain, a indiqué Dmitri Chernyshenko. Les épreuves tests ont été une fantastique répétition générale.» Élément incontournable au succès d’une édition des Jeux Olympiques, le programme des volontaires de la ville hôte. À Sotchi, près de 25 000 personnes seront à pied d’œuvre afin qu’athlètes, officiels et visiteurs vivent 17 jours mémorables. Efronsinia Bondarchuk, volontaire âgée de 23 ans, a su se rendre disponible pour ➤  REVUE OLYMPIQUE 39"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOTCHI 2014  les épreuves tests et d’autres du compte à rebours de ces dernières années. Cette étudiante, fraîchement diplômée de l’Université d’État de Kuban à Krasnodar, est très heureuse de ces opportunités. «C’est un excellent départ pour ma carrière, a-t-elle confié. Peut-être la seule chance dans ma vie de rencontrer autant de gens et d’acquérir toutes ces connaissances. Je me suis fait de nombreux amis dans le monde entier. C’est exceptionnel de pouvoir faire l’expérience d’une manifestation aussi importante.» Avant les Jeux à Sotchi en 2014, le relais de la flamme olympique sera le plus long de l’histoire des Jeux d’hiver. Parti de Moscou le 7 octobre, il réunira quelque 14 000 personnes qui porteront la torche sur plus de 65 000 km, traversant les 83 régions de Russie. L’embrasement de la vasque aura lieu lors de la cérémonie d’ouverture, le 7 février à Sotchi.  Ci-contre: les athlètes se disputeront les médailles d’or sur lesquelles figurent un prisme qui reflète les sommets des montagnes enneigées. Ci-dessous: pendant 123 jours, le relais de la flamme contribuera à faire grandir l’enthousiasme dans toute la Russie."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOTCHI 2014  En photo: Efronsinia Bondarchuk (à gauche) est l’une des quelque 25 000 volontaires de Sotchi 2014 qui contribueront au succès des Jeux par le biais de diverses activités (au centre), tandis que le relais de la flamme olympique (à droite) fait monter l’effervescence dans tout le pays.  * 17 jours de compétition du 7 au 23 février * 7 sports * 98 épreuves * 12 épreuves font leur début aux Jeux Olympiques * 11 nouveaux sites de classe mondiale * Plus de 2 500 athlètes d’environ 80 pays sont attendus en compétition * Le Stade olympique «Fisht» accueillera 40 000 spectateurs pour les cérémonies d’ouverture et de clôture * 25 000 volontaires environ * Près de 3 200 représentants des médias et 10 000 diffuseurs seront accrédités * Sotchi compte 400 000 habitants  Pendant 123 jours, le relais transportera la torche en voiture, en train, en avion, en traineau de rennes et en troïka russe. De près d’un mètre de long et pesant 1,8 kg, la torche décorée de rouge traversera quelque 2 900 villes. «La flamme olympique sera emmenée au fond du lac Baïkal et au sommet du Mont Elbrus. Elle se rendra au Pôle Nord et volera même dans l’espace, a dit Dmitri Chernyshenko. Nous étonnerons le monde!» Au mois de novembre, une torche olympique non allumée a été envoyée vers la Station spatiale internationale, d’où les cosmonautes russes lui ont fait faire une première sortie dans l’espace. Autre première olympique: le choix par vote public des trois mascottes des Jeux lors d’un programme télévisé russe en direct. L’ours polaire, le lièvre et le léopard accueilleront donc chaleureusement les athlètes, invités et autres visiteurs à Sotchi. L’Olympiade culturelle de ces Jeux a aussi connu un succès puisque des millions de personnes de tout le pays ont pris part à une série d’activités culturelles depuis son lancement en 2010. Ces manifestations, concerts, festivals, spectacles, films, expositions et installations d’art, ont offert le meilleur de la culture russe. Les organisateurs ont aussi déjà réfléchi à «l’après-Jeux» afin que ceux-ci soient à l’origine de retombées durables pour la région.  «Nous nous sommes projetés à long terme pour définir un héritage propre aux Jeux qui rénove la ville de Sotchi mais aussi contribue au développement économique, culturel et au respect de l’environnement de la région de Krasnodar», a expliqué Dmitri Chernyshenko. Outre la construction de plusieurs équipements permanents qui permettront la tenue d’autres manifestations sportives de haut niveau à Sotchi, les infrastructures urbaines se sont aussi développées du fait des Jeux. De nouvelles voies ferrées et routières ainsi que des hôtels ont été construits et des milliers d’emplois ont été créés. Mais le 7 février, ce sont les Jeux qui seront l’attraction du monde entier, lorsque le président du CIO, Thomas Bach, déclarera ouvert les XXIIes Jeux Olympiques d’hiver. «Organiser des Jeux Olympiques signifie évoquer l’histoire», aimait à dire Pierre de Coubertin, fondateur du CIO. C’est ce à quoi la ville de Sotchi va s’employer, à l’ultime étape du long périple de l’organisation des Jeux, quand la magie de la flamme olympique pénétrera dans le stade pour embraser la vasque durant cette soirée de février. Telle est la beauté des Jeux Olympiques, leur fascinante intensité, expression de ferventes passions, d’immenses talents d’athlètes, tous différents et venus du monde entier, artistes peignant cette histoire olympique sur la toile à Sotchi. ■  REVUE OLYMPIQUE 41"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOTCHI 2014  Au départ! L’essentiel sur chaque discipline des sports d’hiver  42 REVUE OLYMPIQUE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOTCHI 2014  Ski alpin  Biathlon  Bobsleigh  Épreuves: 10 Athlètes: 320 Dates: 9–22 février  Épreuves: 11 Athlètes: 220 Dates: 8–22 février  Épreuves: 3 Athlètes: 170 Dates: 16–23 février  Le ski alpin est entré au programme olympique en 1936 avec des épreuves combinées, hommes et femmes. À présent, il y a dix épreuves : descente, super combiné, super-G, slalom géant et slalom, ouvertes aux hommes et aux femmes. À Sotchi, la compétition commencera par la descente hommes, le 9 février, dans laquelle le Norvégien Aksel Lund Svindal cherchera à faire mieux que l’argent gagné à Vancouver en 2010.  Le biathlon a débuté aux Jeux d’hiver de 1960, où la seule épreuve était le 20 km individuel, réservé aux hommes. Le relais a été ajouté en 1968, le sprint 10 km en 1980 et les épreuves féminines en 1992. Les épreuves de poursuite et de départ groupé ont été respectivement intégrées en 2002 et 2006. En 2014, le relais mixte fera ses débuts. Après sa superbe saison en Coupe du monde 2013, la Norvégienne Tora Berger, reine du 15 km, s’efforcera de décrocher l’or olympique.  Une course de bobsleigh à quatre a eu lieu aux 1ers Jeux d’hiver en 1924. Quatre ans plus tard, l’épreuve à deux a été ajoutée et, en 2002, l’épreuve à deux féminine. Le duo suisse, Beat Hefti et Thomas Lamparter, a déjà eu un avant-goût du succès à Sotchi en y remportant la Coupe du monde de l’épreuve à deux en février 2013. Le public local ne manquera pas de soutenir Alexander Zubkov qui compte bien mener le bob à quatre russe à la victoire olympique au Centre de sports de glisse «Sanki».  Ski de fond Épreuves: 12 Athlètes: 310 Dates: 8–23 février Le ski de fond ﬁgure au programme depuis 1924. En 2014, il y aura 12 épreuves (6 pour les hommes et 6 pour les femmes) allant du sprint 1,5 km au 50 km départ groupé (hommes) et au 30 km (femmes). La Norvégienne Marit Bjørgen, détentrice du titre olympique en sprint et poursuite individuelle, sera probablement la concurrente à battre pour décrocher une médaille. Son compatriote, Petter Northug, également champion olympique, s’efforcera de maintenir sa domination.  Curling  Patinage artistique  Ski acrobatique  Épreuves: 2 Athlètes: 100 Dates: 10–21 février  Épreuves: 5 Athlètes: 148 Dates: 6–22 février  Épreuves: 10 Athlètes: 282 Dates: 6–21 février  Inscrit au programme des 1ers Jeux d’hiver, le curling n’y a pas réapparu avant 1988, où les titres masculin et féminin ont été respectivement gagnés par la Suisse et le Canada. En 2006 et 2010, les Canadiens ont de nouveau remporté l’or et, les mêmes années, le titre féminin est allé aux Suédoises, menées par Anette Norberg. Cette dernière s’est retirée et avec Margaretha Sigfridsson, sa nouvelle capitaine, la Suède tâchera de décrocher son troisième titre successif.  Outre les traditionnelles épreuves individuelles, en couples et de danse sur glace, une compétition par équipes fera ses débuts à Sotchi. Le but du triple champion du monde canadien Patrick Chan sera de gagner sa première médaille olympique individuelle, tandis que la Sud-Coréenne Yuna Kim s’efforcera de conserver son titre individuel. Les espoirs russes reposeront probablement sur le couple champion du monde, Tatiana Volosozhar et Maxim Trankov.  Quatre nouvelles épreuves au programme à Sotchi : deux chez les hommes, deux chez les femmes, le slopestyle et le halfpipe. Elles rejoindront le ski cross, les sauts et les bosses. Le Britannique James Woods, détenteur de la Coupe du monde de slopestyle, s’efforcera de ramener à son pays sa première médaille olympique, tandis qu’en halfpipe, la Suissesse Virginie Faivre, double championne du monde, sera la femme à battre.  REVUE OLYMPIQUE 43"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOTCHI 2014  Hockey sur glace  Luge  Combiné nordique  Épreuves: 2 Athlètes: 468 Dates: 8–23 février  Épreuves: 4 Athlètes: 110 Dates: 8–13 février  Épreuves: 3 Athlètes: 55 Dates: 12–20 février  Le hockey sur glace a ﬁguré à chaque édition des Jeux d’hiver et les femmes y ont débuté à Nagano en 1998. À Vancouver en 2010, les Canadiens ont vécu un conte de fées en ﬁnale grâce au but sécurisant la médaille d’or de Sidney Crosby, 7 min 40 sec après le début de la prolongation arrêtant le score à 3 à 2 contre les États-Unis. Et les Canadiennes l’ont aussi emporté contre les Américaines, 2 à 0, décrochant ainsi leur troisième titre consécutif.  La luge a été intégrée au programme des Jeux de 1964 à Innsbruck et y est demeurée depuis lors. À Sotchi, le relais par équipes mixtes fera ses débuts. Lors de la Coupe du monde de 2013, les Allemands ont remporté tous les titres: Felix Loch, champion olympique en titre, et Natalie Geisenberger, championne du monde 2013, ont décroché la victoire en simple tandis que Tobias Wendl et Tobias Artl ont gagné en double.  Skeleton  Patinage de vitesse sur piste courte  Épreuves: 2 Athlètes: 50 Dates: 13–15 février  Épreuves: 8 Athlètes: 120 Dates: 10–21 février  L’épreuve masculine de skeleton ﬁgurait au programme des Jeux de 1928 et 1948, qui ont chacun eu lieu sur la célèbre piste de Cresta à SaintMoritz, d’où ce sport est originaire. Après 54 ans d’absence, le skeleton a réintégré le programme à Salt Lake City en 2002, inaugurant une épreuve féminine. La compétition olympique consiste en quatre manches sur deux jours et la médaille d’or va au concurrent combinant le temps le plus rapide.  Le patinage de vitesse sur piste courte a été ajouté au programme olympique en 1992, incluant une épreuve individuelle et un relais, chacun ouvert aux hommes et aux femmes. D’autres distances individuelles ont été ajoutées en 1994 puis le 1 500 m en 2002 pour les hommes et les femmes. À Sotchi, hommes et femmes concourront dans le 500 m, 1 000 m et 1 500 m. Il y aura un relais 3 000 m féminin et 5 000 m masculin.  Saut à ski  Snowboard  Patinage de vitesse  Épreuves: 4 Athlètes: 100 Dates: 8–17 février  Épreuves: 10 Athlètes: 252 Dates: 6–22 février  Épreuves: 12 Athlètes: 180 Dates: 8–22 février  Le saut à ski a toujours ﬁguré au Jeux. En 2014 à Sotchi, les femmes concourront pour la première fois. De 1924 à 1960, seul le saut individuel au grand tremplin a eu lieu aux Jeux. En 1964, une épreuve individuelle au petit tremplin a été ajoutée suivie d’une épreuve par équipes au grand tremplin en 1988. L’Autrichien Gregor Schlierenzauer a remporté le titre général de la Coupe du monde 2013 tout comme la Japonaise Sara Takanashi, championne des JOJ 2012.  44 REVUE OLYMPIQUE  Le combiné nordique, qui allie le saut à ski à une course de ski de fond, est au programme olympique depuis 1924. Les points acquis au saut à ski déterminent l’ordre de départ de la course de ski de fond mais aussi les boucles de pénalité. Le Français Jason Lamy-Chappuis, vainqueur en individuel au petit tremplin et à la course de 10 km à Vancouver en 2010, sera parmi les favoris après avoir terminé deuxième du classement général de la Coupe du monde 2013.  Le snowboard est la discipline la plus récente des Jeux d’hiver, entré en 1998 à Nagano avec le slalom géant et le half-pipe. Le snowboard cross a été ajouté en 2006 et à Sotchi en 2014, ce sont le slalom parallèle spécial et le slopestyle qui débuteront. Les deux derniers titres olympiques de half-pipe sont successivement revenus à l’Américain Shaun White qui a en plus conquis les spectateurs à Vancouver en 2010, décrochant un record olympique de 48.4 points sur 50.  Le patinage de vitesse fait partie des Jeux d’hiver depuis leur première édition en 1924. Les épreuves féminines ont été ajoutées en 1960. À Sotchi, hommes et femmes disputeront les mêmes épreuves du 500 m, 1 000 m, 1 500 m et 5 000 m auxquelles s’ajouteront un 10 000 m pour les hommes et un 3 000 m pour les femmes. Depuis 2006, hommes et femmes disputent également une poursuite par équipes. À Sotchi, les favoris sont les Néerlandais Ireen Wüst et Sven Kramer."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOTCHI 2014  Quoi de neuf? Douze nouvelles épreuves (trois mixtes, quatre masculines et cinq féminines) feront leurs débuts au programme olympique à Sotchi. Biathlon: relais – mixte Équipes de deux hommes et deux femmes. Celles-ci partiront les premières, pour deux segments de 6 km. Les hommes suivront avec deux segments de 7,5 km. Patinage artistique: par équipes – mixte Équipes de six patineurs: un homme, une femme, un couple et un couple de danse sur glace. Les points seront attribués pour chaque enchaînement et l’équipe qui cumulera le plus de points remportera l’or. Luge: relais par équipes – mixte Chaque pays alignera des concurrents pour le simple femme, le simple homme et deux hommes pour le double. Tous descendront la piste les uns après les autres, et le chronomètre ne sera arrêté qu’à l’arrivée du troisième. Half-pipe en ski – hommes et femmes Chaque skieur exécute entre autre une série de grands sauts dans le half-pipe avant d’être jugé sur la difﬁculté technique, le style, la ﬂuidité, la diversité et l’exécution. Slopestyle en ski – hommes et femmes Les skieurs combinent sauts et ﬁgures sur un parcours agrémenté de rails et tremplins avant d’être notés sur l’exécution, la difﬁculté de la ligne, la réception et l’utilisation faite du parcours. Slopestyle en snowboard – hommes et femmes Les athlètes sont notés à la ﬁn du parcours composé de rails et de divers tremplins tandis qu’ils combinent des grands sauts et des ﬁgures techniques en un passage. Slalom parallèle en snowboard – hommes et femmes Deux surfeurs affrontent simultanément le même parcours sur deux pistes parallèles, balisées par des portes et des drapeaux triangulaires. Saut à ski - femmes Cette épreuve au petit tremplin de Sotchi 2014 marquera la première participation des femmes en saut à ski aux Jeux Olympiques.  REVUE OLYMPIQUE 45"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOTCHI 2014  Merveilles de l’hiver Les Jeux de 2014 à Sotchi seront les premiers Jeux d’hiver à rassembler les sites de compétition en deux «complexes» distincts, avec 11 nouveaux sites qui offriront aux athlètes une scène sportive de première classe.  46 REVUE OLYMPIQUE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOTCHI 2014  REVUE OLYMPIQUE 47"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOTCHI 2014  Centre de patinage «Adler Arena»  Centre de curling «Ice Cube»  Arène «Shaiba»  Patinage de vitesse 8 000 places Cet ovale ressemble à une faille de glace, ses parois en biseau et ses baies en vitrail triangulaire lui donnent l’allure d’un cristal. Les parois ont été rendues aussi translucides que possible pour que les spectateurs puissent jouir du panorama environnant. La glace de la piste est conçue pour obtenir les meilleures performances des patineurs.  Curling 3 000 places L’architecture de ce site rappelle les contours lisses et bien tournés d’une pierre de curling, ce qu’accentue encore le poli soyeux de la façade. Cet équipement au concept simplissime symbolise la démocratie et l’accessibilité.  Hockey sur glace 7 000 places Ce site tire son nom du mot russe pour le palet de hockey et de «shaybu», mot crié par les fans russes qui encouragent leur équipe nationale lors des grands championnats. Un palet symbolique a été placé dans les fondations lors de la construction. La façade circulaire est recouverte de motifs bleus et blancs ondulant comme un rideau de neige.  48 REVUE OLYMPIQUE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOTCHI 2014  Palais de glace «Bolshoï»  Palais des sports de glace «Iceberg »  Stade olympique «Fisht»  Hockey sur glace 2 000 places Ce bâtiment qui ne passe pas inaperçu fait penser à une immense goutte d’eau gelée. Il est équipé d’un système innovateur de transfert des ﬂuides caloriﬁques nécessaires à la création et à l’entretien de surfaces gelées de haute performance. Ce système sert aussi à la climatisation et au contrôle régulier et ﬁable de la température pour une qualité pérenne de la glace aﬁn de garantir la meilleure performance et la sécurité des patineurs.  Patinage artistique et de vitesse sur piste courte 12 000 places Les courbes ﬂuides et arrondies de sa façade de verre évoquent la trajectoire tout en souplesse des patineurs artistiques à la réception d’un triple boucle piqué. Fait incroyable, il ne faudra que deux heures pour préparer la glace entre le patinage artistique et le patinage de vitesse sur piste courte pendant les Jeux.  Cérémonies d’ouverture et de clôture 40 000 places Les œufs de Fabergé aux incrustations de diamant, célébrités russes, ont inspiré la coque unique de ce stade. La toiture en polycarbonate translucide, qui servira à projeter des illuminations durant les Jeux, confère à l’ensemble l’apparence d’un massif montagneux, en harmonie avec le paysage de la vallée Imeretinskaya et les monts du Caucase.  Complexe côtier Le parc olympique comprend cinq arènes construites pour l’occasion et le splendide stade olympique “Fisht” de 40 000 places. REVUE OLYMPIQUE 49"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOTCHI 2014  Complexe de montagne À près de 48 km de Sotchi, ce complexe aura son propre village olympique, au milieu du grand domaine alpin.  50 REVUE OLYMPIQUE  Complexe de tremplins «RusSki Gorki»  Parc X-treme «Rosa Khutor»  Saut à ski 7 500 places Sur le versant nord du massif de l’Aibga, dans le village d’EstoSadok, ce site est situé à la jonction de deux massifs aﬁn de s’intégrer parfaitement à l’environnement. Son nom joue avec l’abréviation de Russie: «Rus» et le terme «ski».  Snowboard, ski acrobatique 4 000 places (centre de ski acrobatique), 6 250 places (parc de snowboard) À l’ouest du plateau de Rosa Khutor, le parc sera le théâtre des compétitions de snowboard et de ski acrobatique. Les idéales conditions d’enneigement conjuguées aux pistes techniques aideront à la renommée de ce site, prévu sur le long terme, pour attirer d’autres compétitions mondiales. La piste de ski cross de 1,2 km et son dénivelé de 213 m sera un autre atout."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOTCHI 2014  Photo principale Le Centre alpin «Rosa Khutor», situé dans le massisf de l’Aibga, accueillera toutes les disciplines de ski alpin.  Complexe de ski de fond et de biathlon «Laura»  Centre alpin «Rosa Khutor»  Centre de sport de glisse «Sanki»  Ski de fond, biathlon 7 500 places Situé sur la crête et les pentes du massif Psekhako, à moins de 10 km au nordest de Krasnaya Polyana, ce complexe est exceptionnel car il comprend deux aires, l’une pour le biathlon et l’autre pour le ski de fond avec, pour chaque sport, des pistes, zones de départ et d’arrivée séparées. Le nom du site vient de la turbulente rivière aux nombreuses cascades qui prend sa source sur le versant méridional de l’Assar, dans le parc naturel du Caucase.  Ski alpin 7 500 places Situé dans le massif de l’Aibga, à environ 80 km de Sotchi, la station de Rosa Khutor accueillera toutes les disciplines de ski. Bernhard Russi, célèbre concepteur de pistes de ski et champion olympique, a conçu les pistes de compétition, totalisant une distance de 20 km ainsi qu’une piste pour la descente masculine de près de 3 500 m agrémentée d’un dénivelé de 1 075 m.  Bobsleigh, skeleton, luge 5 000 places À environ 60 km au nord-est de Sotchi, le Centre a été construit dans la station d’Alpika avec son aire d’arrivée à Rzhanaya Polyana. La piste d’1,5 km, avec 18 virages et un dénivelé de 131,9 m, est dotée d’une technologie de pointe pour préparer la glace, ce qui assure un contrôle optimal de la température sur toute sa longueur.  REVUE OLYMPIQUE 51"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1972  IMAGES OLYMPIQUES CLASSIQUES SAPPORO BIATHLON  Magnar Solberg, biathlète norvégien, était venu aux Jeux d’hiver de 1972 à Sapporo pour défendre son titre dans le 20 km individuel après sa victoire à Grenoble, quatre ans plus tôt. Il a rapidement pris la tête pour finalement décrocher la première place, battant l’Allemand de l’Est Hansjörg Knauthe de 12 secondes. Il demeure le seul biathlète à avoir remporté le 20 km individuel olympique à deux reprises consécutives. Photo: CIO"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "JEUX OLYMPIQUES À TOKYO EN 2020  DÉCOUVRIR DEMAIN AVEC LE RETOUR DES JEUX OLYMPIQUES À TOKYO EN 2020, JACK GALLAGHER, RESPONSABLE DU CAHIER DES SPORTS DU JAPAN TIMES, S’INTÉRESSE AUX RÉPERCUSSIONS DE CETTE DÉCISION POUR LA VILLE QUI A ACCUEILLI LES JEUX EN 1964. IL PRÉSENTE AUSSI CE À QUOI LES ATHLÈTES ET LEURS FANS PEUVENT S’ATTENDRE DANS SEPT ANS.  54 REVUE OLYMPIQUE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "JEUX OLYMPIQUES À TOKYO EN 2020  L  e Japon tout entier a explosé de joie quand Jacques Rogge, président sortant du CIO, a annoncé que Tokyo avait triomphé du scrutin d’attribution des Jeux Olympiques en 2020. La nouvelle, parvenue dans le pays au petit matin, a immédiatement été reprise à la Une des médias. Toute la journée, les télévisions ont diffusé des programmes en direct et les journaux de la capitale ont publié des éditions spéciales. Quant au public, rassemblé aux points de retransmissions publiques, il s’est réjoui sans frein. L’effervescence s’est poursuivie durant plusieurs jours: les plus âgés ont rappelé les souvenirs de 1964, année également  de l’arrivée du premier Shinkansen (train à grande vitesse) et les plus jeunes ont fait part de leur rêve de représenter l’Hinomaru (l’emblème japonais). La candidature de Tokyo l’a emporté sur celle d’Istanbul au dernier tour de scrutin, par 60 voix contre 36. Ceci marque l’apogée de plusieurs années de minutieuse planification menée par Tsunekazu Takeda, président du Comité olympique japonais, et Masato Mizuno, directeur général de la candidature. Cette victoire advient après plusieurs candidatures infructueuses à l’organisation des Jeux d’été: Nagoya (1988), Osaka (2008) et Tokyo (2016). Le Japon qui, outre les Jeux d’été de 1964, ➤  REVUE OLYMPIQUE 55"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "JEUX OLYMPIQUES À TOKYO EN 2020  Ci-dessous: le Tokyo Metropolitan Gymnasium, qui a accueilli les épreuves de gymnastique en 1964, abritera le tennis de table en 2020. À droite: les résidents de Tokyo célèbrent les résultats de l’élection de la ville hôte.  56 REVUE OLYMPIQUE  a aussi accueilli les Jeux d’hiver à Sapporo en 1972 et à Nagano en 1998, s’est imposé cette fois-ci avec la devise «Découvrir demain». L’un des atouts de la candidature est sa «compacité». Près de 75 % des sites sportifs sont à 8 km du village olympique, situé sur le front de mer d’Harumi, dans la baie de la capitale. Et 22 des 37 équipements seront construits pour l’occasion. La majorité des épreuves aura lieu à Tokyo sauf des matches du tournoi de football qui seront joués à Yokohama, Saitama, Sapporo, Rifu et dans la préfecture de Miyagi. Quelques sites des Jeux de 1964 serviront de nouveau. Le stade national de Tokyo, théâtre des cérémonies d’ouverture et de clôture ainsi que des compétitions d’athlétisme, sera complètement repensé et remplacé par une arène à la toiture rétractable, de 80 000 places. Il accueillera la finale de la Coupe du monde de rugby en 2019.  Les Jeux, prévus du 24 juillet au 9 août 2020, permettront d’aider le Japon à se repositionner sur la scène mondiale du monde des affaires. L’économie japonaise lutte depuis près de deux décennies. Mais la venue des Jeux implique un renouvellement des infrastructures et la relance du tourisme sans compter d’autres retombées économiques à long terme. Hôte de nombreuses grandes manifestations sportives des 50 dernières années comme la Coupe du monde de football de 2002, co-organisée avec la Corée du Sud, le Japon s’apprête à relever un formidable défi en vue d’accueillir le monde entier dans sept ans. «Nous sommes convaincus que nos amis japonais proposeront des Jeux excellents, a déclaré Jacques Rogge. Nous pouvons leur faire confiance, ils organiseront des Jeux sûrs, bien pensés et placeront le bien-être des athlètes en tête. Je sais qu’ils seront au cœur des Jeux.»"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "JEUX OLYMPIQUES À TOKYO EN 2020  La présentation donnée lors de la Session du CIO cette année s’est ouverte par une intervention éloquente de la princesse Takamado, en présence du Premier ministre Shinzo Abe, de Tsunekazu Takeda et Masato Mizuno. L’hommage émouvant de Mami Sato, paralympienne en saut en longueur, décrivant comment le sport l’avait sauvée du désespoir après la perte d’une jambe du fait d’un cancer, a sonné juste. «Mon cœur battait la chamade (avant l’annonce), à présent je suis ravi, a déclaré Shinzo Abe à Kyodo News. Nous répondrons aux attentes et au soutien en organisant ces Jeux Olympiques avec succès. Je crois que nous avons fait passer le message que nous pouvions le faire en toute sûreté.» Membre éminent de la communauté olympique depuis de nombreuses années, Masato Mizuno avait rappelé en juin 2011, devant l’association des journalistes  sportifs étrangers du Japon à Tokyo, combien les Jeux pouvaient être un catalyseur de changement. «Nous défendons les valeurs olympiques: excellence, amitié et respect. Au-delà de ces Jeux, nous voulons aussi développer notre société et démontrer la force du sport.» Cavalier ayant participé aux Jeux de 1972 à Munich et de 1976 à Montréal, Tsunekazu Takeda a exprimé les sentiments de nombre de ses compatriotes quand il a commenté la sélection de Tokyo. «J’attends ce bonheur depuis tant d’années, a-t-il confié. C’est un honneur d’être choisi comme hôte.» Il admet que l’épreuve a été longue et ardue, et que désormais le vrai travail commence! «La famille olympique nous fait confiance pour que nous organisions les Jeux mémorables que nous avons promis et nous relevons le défi, a-t-il précisé. L’expérience sera inoubliable pour chacun  des membres de la famille olympique, des athlètes et des spectateurs. «Nous sommes impatients de passer à l’action. Ce sera un superbe événement, en plein cœur de notre dynamique capitale. C’est avec sérieux et humilité que nous prenons en charge cette immense responsabilité et nous œuvrerons sans relâche pendant les sept prochaines années pour organiser ce qui sera à n’en pas douter la plus grande manifestation mondiale de 2020.» ■  TSUNEKAZU TAKEDA PRÉSIDENT DU CNO JAPONAIS ET RESPONSABLE DE LA CANDIDATURE  j’ai pu partager cette joie avec l’équipe et tous les Japonais. Une sensation de bonheur immense s’est répandue dans les jours qui ont suivi l’élection et notre peuple a été ému et fier de la décision du CIO. Quelles ont été les clés du succès?  Que ressentez-vous après avoir remporté l’organisation des Jeux en 2020 et avoir investi autant de temps et d’efforts ces deux dernières années? C’est un sentiment singulièrement fantastique de joie et d’honneur. Je ressens encore cette excitation incroyable quand j’ai vu Tokyo écrit sur le carton qu’a brandi Jacques Rogge. Toute la campagne de la candidature a été une expérience fantastique, pleine d’émotion et de moments dont je me souviendrai toujours. J’étais d’autant plus heureux que  C’est un succès pour tout le Japon. La nation s’est unie pour combiner ses forces et faire de la candidature de Tokyo qu’elle soit la meilleure. Je crois que le CIO a senti notre ardent désir national ainsi que les nombreux avantages de la tenue des Jeux à Tokyo. Nous avons une vision mondiale qui sert le sport en le renforçant en cette époque difficile et en constante mutation. Tokyo est une valeur sûre. Toute la famille olympique tirera des avantages de nos trois forces majeures: organisation, célébration et innovation. Que devra faire le comité d’organisation des Jeux (TOCOG) ces sept prochaines  années pour que ce soit une réussite? La réussite ne dépend pas uniquement de ce que fera le TOCOG mais aussi de l’ensemble du pays. Nous sommes enchantés d’avoir l’honneur de pouvoir organiser les Jeux en 2020 et nous nous affairons désormais à la mise en place du TOCOG, sans perte de temps. En nous préparant à l’avance, nous pourrons nous concentrer sur les extras qui feront la différence entre de bons Jeux et des Jeux fantastiques. À quel point est-il important que le pays hôte ait de bons résultats aux Jeux? C’est important pour deux raisons: l’inspiration et la célébration. Sur le long terme, les résultats de l’équipe nationale sont essentiels pour renforcer le sport au Japon. Simultanément, cela donnerait de l’inspiration aux nouvelles générations si le Japon pouvait battre son record de médailles en 2020!  REVUE OLYMPIQUE 57"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1928  IMAGES OLYMPIQUES CLASSIQUES SAINT MORITZ PATINAGE ARTISTIQUE  La Norvégienne Sonja Henie n’avait que 15 ans quand elle a fait battre les cœurs aux Jeux d’hiver de 1928, obtenant la meilleure note de six des sept juges, décrochant ainsi la médaille d’or du patinage artistique. Elle a conservé ce titre en 1932 et en 1936 tout en remportant 10 titres mondiaux successifs entre 1927 et 1936. Devenue une star du cinéma hollywoodien, elle a tourné dans plusieurs grands succès entre 1936 et 9148. Photo: CIO"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 59,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg60.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "STARS DE SOTCHI  ,,  Il faut être ê un bon athlète, garder la tête froide mais gard rester sensible. Nombre de skieurs ne pratiquent que cette discipline et pour eux, c’est plus répétitif que pour moi. Être polyvalent requiert de nombreuses qualités. Passer d’une discipline à l’autre n’est pas facile mentalement. Le slalom, et sa quantité de virages, est exigeant physiquement alors que la descente est une question de sensations, de rapidité p dité et de courage.  ,,  TINA MAZE LA SLOVÈNE DE 30 ANS A GAGNÉ DEUX MÉDAILLES D’ARGENT OLYMPIQUES À VANCOUVER EN 2010 ET A RÉALISÉ UNE COUPE DU MONDE HISTORIQUE EN 2013. ELLE EST MONTÉE SUR LE PODIUM UN NOMBRE RECORD DE 24 FOIS, COMPTABILISANT AINSI PLUS DE POINTS EN UNE SAISON QUE TOUT AUTRE SKIEUR.  60 REVUE OLYMPIQUE  J’adore la musique et la motivation mo i qu’elle donne. C’est une énergie spéciale! D’ailleurs, je suis aux anges lorsqu’il y a de la musique aux compétitions. Rien de tel qu’un peu de mise en scène! En ce moment, j’écoute beaucoup de musique italienne mais parmi mes favoris figurent aussi Queen,, Beyoncé et Lady Gaga.  ,,  ,,  Je suis le même rituel avant la course depuis des années. Je me concentre d sur l’échauffement physique et musculaire. À l’entraînement, nous enchaînons tellement de descentes qu’au moment du départ, on se laisse porter par le courant; on fait confiance ce à son corps et on ne pense pas trop. rop.  ,,  ,,  ,,  En dehors deho de la compétition, j’aime rattraper le sommeil perdu, me ratt détendre et récupérer. J’aime aller à la plage et y pratiquer la planche à voile et le volleyball de plage. Mais je ne pense pas pouvoir être meilleure dans un autre sport que dans le ski, en tout cas pour pouvoir concourir aux Jeux Olympiques… ues…  ,,"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 60,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg61.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "STARS DE SOTCHI  ,,  ,,  Le ski e est un sport qui requiert des compétences variées. Il y a plus de c mouvements, de sensibilité ou de «ressenti» que dans d’autres sports. D’ailleurs, je connais de bons musiciens qui sont de bons skieurs car ils en ont une bonne perception – et beaucoup de bons skieurs sont aussi musiciens. Skier, c’est comme de la poésie. C’est un sport qui peut ut être dur et très sensible.  ,, ,,  ,,  Skier paraît p simple mais c’est un sport qui inflige une énorme pression à l’ensemble du corps, surtout énor dans les virages. Il faut donc beaucoup s’entraîner. C’est pourquoi je souhaite obtenir la même condition physique que celle d’un sprinter comme Usain n Bolt!  ,,  ,,  Les han hanches subissent la pression la plus forte. Tout le pr corps travaille énormément mais les hanches doivent vous soutenir dans les virages,, surtout s’il y a des bosses. ses.  Cette année, an aux Championnats du monde à Schladming, j’ai gagné une médaille d’or mais j’ai manqué deux occasions d’en gagner d’autres. J’ai travaillé dur pour être en pleine forme aux Jeux à Sotchi où je tenterai ma chance, cette fois, dans les cinq disciplines.  ,,  ,,  ,,  ,,  Je poste post beaucoup de messages sur Facebook mes et suis convaincue que même si je ne connaissais pas mon succès actuel, je communiquerais autant car c’est un bon moyen d’être e en phase avec soi-même.  Nous av avons besoin de beaucoup d’équipements, c’est la plus grande contrainte de ce sport. En ce c’ moment, là où je m’entraîne, j’ai 50 paires de skis. Et avec toutes les tenues d’hiver et les chaussures de ski, je transporte 800 kilos de bagages! Heureusement, j’ai toute une équipe qui m’aide e mais ce n’était pas le cas à mes débuts.  ,, REVUE OLYMPIQUE 61"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 61,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg62.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "STARS DE SOTCHI  ,,  Sur la glace, g je suis une concurrente coriace et une perfectionniste. Si quelque chose se passe mal ou que j’ai un mauvais moment, je le prends très à cœur et suis contrariée. Je crois que mon plus grand défi est de savoir prendre du recul et de me focaliser sur le match à venir. C’est quelque chose que j’ai travaillé ces dernières années car je ne peux pas tout contrôler et dois accepter de passer à autre chose. J’ai horreur de perdre mais cela arrive et c’estt la vie!  ,,  La cérémonie céré d’ouverture est certainement mon meilleur me ll souvenir de Vancouver car c’était une expérience fabuleuse et mes parents étaient dans les tribunes. Ils étaient entourés de milliers de personnes mais je les ai retrouvés après. C’était très émouvant, on en avait les larmes aux yeux! Par contre, notre défaite contre les Canadiennes est la chose la plus contrariante qui s’y est produite. C’était fantastique de se retrouver en finale, mais cette défaite restera une source de motivation jusqu’à un prochain match!  ,,  ,,  Nous no nous entraînons six jours par semaine. si Le lundi, mercredi et samedi, nous faisons de la musculation pendant une heure et demie à deux heures et nous sommes sur la glace, environ trois heures par jour, du lundi au vendredi. Pour nous, chaque jour est une ne journée de travail.  ,,  KACEY BELLAMY APRÈS UNE MÉDAILLE D’ARGENT DOUCEAMÈRE À VANCOUVER EN 2010, KACEY BELLAMY, DÉFENSEUR DE L’ÉQUIPE AMÉRICAINE DE HOCKEY SUR GLACE, DÉVOILE COMMENT ELLE SE PRÉPARE À LA CONQUÊTE DE L’OR À SOTCHI.  62 REVUE OLYMPIQUE  ,,"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 62,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg63.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "STARS DE SOTCHI  ,,  Je crois que ces trois dernières années et demie, l’ensemble de notre programme a de changé. Nous avons intégré énormément de nouveaux talents et nous travaillons beaucoup plus dur que jamais auparavant. Nous sommes à pied d’œuvre mentalement et physiquement et je crois qu’à notre arrivée ivée à Sotchi nous serons fin prêtes à jouer. r.  ,, ,,  ,,  ,,  Quant à moi, je travaille surtout mon patinage et la rapidité de mon jeu de pat pieds. En tant que défenseur, je dois insister sur le jeu rapide dans les coins, sur l’aspect physique et sur l’habileté à patiner à reculons. Je m’y entraîne avec détermination tous s les jours et j’en suis fière.  ,,  ,,  ,,  Évidem Évidemment, je mange bien et j’essaie d’avoir le maximum m de protéines dans mon régime. Les glucides sont aussi importants car, à l’entraînement, le corps a besoin de carburant. Nous prenons le sujet de l’alimentation très au sérieux, c’est un élément clé. J’aurais aimé savoir il y a quatre ans ce que je sais aujourd’hui! Je m’efforce de trouver un équilibre car j’adore les légumes et manger sainement mais je crois qu’on peut aussi, de temps en temps, se faire e plaisir avec ce qu’on aime et ce dont on a envie.  J’ai un compte sur Twitter Tw t et sur Facebook et je m’efforce d’y partager ce que nous faisons avec l’équipe. Mais je ne dirais pas que je suis très active sur ces réseaux. J’aime bien m’y connecter de temps en temps pour voir ce que mes coéquipières ou d’autres personnes es écrivent.  ,,  Tout le monde m veut être le meilleur dans ce qu’il meill fait. Et je sais que je joue encore aujourd’hui pour la compétition. La médaille d’or est toujours dans un coin de notre tête parce que cela fait 16 ans que l’équipe américaine n’en a plus gagné et que, pour l’instant, c’est ce qui nous motive et qui nous us pousse à nous entraîner. ner.  ,, REVUE OLYMPIQUE 63"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 63,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg64.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "RECHERCHE OLYMPIQUE  À droite: la collection de la bibliothèque du Centre d’Études Olympiques contient quelque 24 000 publications olympiques et relatives au sport.  ÉLARGIR LES HORIZONS CHAQUE ANNÉE, DES MILLIERS DE CHERCHEURS, PROFESSEURS ET ÉTUDIANTS DU MONDE ENTIER CHERCHENT À MIEUX COMPRENDRE LES MULTIPLES ASPECTS DES JEUX OLYMPIQUES, DU MOUVEMENT OLYMPIQUE ET DE SES VALEURS. JOANNA HUNTER NOUS EXPLIQUE ICI COMMENT LE CENTRE D’ÉTUDES OLYMPIQUES DU CIO ENCOURAGE ACTIVEMENT CETTE RECHERCHE.  É  crivain, universitaire et sportif accompli, Pierre de Coubertin, fondateur du Mouvement olympique moderne, était convaincu de l’importance de combiner le sport et le milieu universitaire. C’est la raison pour laquelle il a tenu à ce que le Congrès fondateur des Jeux Olympiques modernes, organisé à Paris en juin 1894, se déroule à la Sorbonne, institution d’éducation supérieure, s’il en est. Après la première édition des Jeux Olympiques modernes à Athènes en 1896, il est l’instigateur du  64 REVUE OLYMPIQUE  2e Congrès olympique du CIO, un an plus tard au Havre, France. Rappelant cette manifestation dans ses mémoires, il écrit: «Imprimer cette direction immédiatement après les Jeux, c’était rappeler la nature intellectuelle et philosophique de mon initiative et, dès l’origine, situer le rôle du CIO bien au-delà d’un simple groupement de sports.» Plus de cent ans après, nul doute que Coubertin apprécierait la réponse du monde académique actuel à cette passion ainsi que l’intensité avec laquelle réflexion ➤"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 64,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg65.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "RECHERCHE OLYMPIQUE  REVUE OLYMPIQUE 65"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 65,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg66.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "RECHERCHE OLYMPIQUE  et débats intellectuels portent aujourd’hui sur le phénomène olympique. Non plus limité à la science sportive, que d’aucuns considèrent comme le domaine traditionnel des Jeux, l’intérêt pour le Mouvement olympique s’est étendu et touche désormais les humanités et les sciences sociales. Les récentes recherches reflètent cette disparité et l’envergure du rôle des Jeux qui va de la régénération urbaine à l’action du CIO avec les Nations Unies. La riche trame de cette recherche est le fruit de travaux de nombreuses personnes de divers pays et origines culturelles. Encourager et promouvoir cet intérêt du monde académique pour l’Olympisme, telle est la mission du Centre d’Études Olympiques (CEO) du CIO, installé dans ses propres locaux, à côté du Musée Olympique, face au lac Léman à Lausanne, Suisse. Centre de référence des connaissances olympiques, le CEO donne accès aux collections patrimoniales du CIO et à une vaste sélection de matériel de référence, qu’il s’agisse des quelque 24 000 publications de la bibliothèque sur l’Olympisme (dont bon nombre produites par le CIO et les comités d’organisation sont désormais accessibles en ligne) ou du quasi kilomètre linéaire de documents qui remontent à 1894 et constituent les archives historiques. Rien d’étonnant à ce que le CEO soit essentiel aux universitaires et qu’il permette d’aider les communautés olympiques à se maintenir à flot en termes de travail universitaire dans le monde, ainsi que d’aider à donner forme à celui-ci. La collaboration du CEO avec les universités est ancienne et féconde, puisque 78 bourses de recherche ont déjà été attribuées à des étudiants postgradués, dans le cadre de son programme de bourses de recherche pour étudiants de doctorat (anciennement nommé programme de bourses de recherche pour étudiants post-gradués) depuis 1999. Ce programme a pour but de soutenir et de promouvoir la recherche qui porte sur le Mouvement olympique, son histoire, ses idéaux et son impact sur la société et la culture contemporaines selon un angle humain et social. Destiné à des chercheurs en début de carrière, le programme a été établi avec la conviction que les étudiants en doctorat se destineraient à l’enseignement et partageraient avec leurs propres étudiants leur intérêt pour  66 REVUE OLYMPIQUE  l’Olympisme, ouvrant ainsi la voie à la poursuite de leur recherche olympique à un niveau académique plus poussé. Ana Maria Miragaya a reçu une bourse du CEO pour son projet sur l’inclusion des femmes aux Jeux Olympiques et au sein des entités organisationnelles du CIO. Elle a depuis poursuivi ses travaux dans le champ olympique après être devenue enseignante à l’Universidade Estácio de Sá Petrópolis au Brésil. «Le programme de bourses du CEO a été capital pour ma participation aux activités académiques olympiques, reconnaît Ana Maria. J’ai pu rassembler les données de ma thèse de doctorat, mener des recherches dans les secteurs des études olympiques, coéditer des ouvrages sur l’Olympisme, réaliser des séminaires et des conférences sur des thèmes olympiques et même démarrer un laboratoire d’études olympiques à l’université où je travaille à l’heure actuelle. Depuis ma thèse, j’ai pu aider des étudiants dans leurs projets de recherche, les soutenir dans leurs objectifs et accroître leurs connaissances dans le secteur des études olympiques qui s’est considérablement développé récemment.» La capacité du CIO à soutenir et à sensibiliser les chercheurs concernés a encore évolué avec la création, en 2013, d’un programme de bourses de recherche olympique avancée et d’un 3e volet sous forme d’appels publics à des propositions. Tirant parti du succès du programme de niveau doctorat, ce nouveau programme de bourses est destiné à des professeurs d’université, assistants, et autres chercheurs ayant déjà obtenu leur doctorat. Les bourses seront distribuées à des chercheurs établis qui œuvrent sur des sujets choisis par le CIO. L’idée soulignée par Maria Bogner, responsable du CEO, est «d’attirer l’attention sur l’Olympisme puis de la promouvoir et l’entretenir. Parallèlement, nous souhaitons obtenir les analyses les plus élevées de la part des chercheurs sur des sujets qui intéressent spécifiquement le CIO et le Mouvement olympique.» Parmi les domaines de recherche retenus pour 2014 et 2015, on retiendra les Jeux Olympiques comme plateforme unique de diffusion des valeurs olympiques dans le monde entier, les considérations éthiques et pratiques de l’usage de la technologie en sport de haut niveau, le rôle de l’entourage dans la carrière sportive et éducative de  À droite: les chercheurs viennent monde entier pour consulter la documentation du CEO."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 66,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg67.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "RECHERCHE OLYMPIQUE  l’athlète, et enfin la relation entre les jeunes, l’activité physique et l’Olympisme. Troisième volet de ce plan de recherche, les appels publics aux propositions à destination de la communauté universitaire. Ils ont été conçus pour répondre aux besoins de recherche spécifiques du CIO. «En créant ainsi un pont entre le Mouvement olympique et l’université, explique Nuria Puig, responsable des relations du CEO avec les universités, le CEO sera en bien meilleure position pour réunir les deux parties et permettre une recherche mieux ciblée et plus efficace pour le plus grand bénéfice du Mouvement olympique et de la communauté mondiale. Ce lien sera renforcé au niveau national par la collaboration des Comités Nationaux  Olympiques avec les représentants universitaires de leur propre pays.» Cette idée de collaboration avec les universités résonne bien avec une déclaration récente du nouveau président du CIO, Thomas Bach: «Dialoguer signifie également s’ouvrir à notre société moderne et collaborer dans les domaines de la culture, de la politique, de l’éducation, des affaires, des médias et des sciences, etc. Nous avons besoin de cette contribution car le sport n’est plus une île dans l’océan que serait la société. Le sport, hautement respecté et populaire, fait partie intégrante de la société. Nous pouvons être fiers et heureux que le CIO exprime une diversité d’expertise aussi fascinante. Et le dialogue ouvert que nous pouvons entretenir avec  les autres secteurs de la société produira de nouvelles idées et sera source de progrès pour notre Mouvement olympique.» Grâce à son nouveau plan de recherche qui étend son soutien aux chercheurs, le Centre d’Études Olympiques continue de faire en sorte que le CIO collabore avec le monde universitaire et que ce dialogue dispose d’autant d’informations que possible. ■ Les chercheurs sont invités à s’abonner à la lettre d’information trimestrielle du CEO pour être informés de ses activités, de celles du CIO d’intérêt pour la communauté universitaire et sur les études olympiques universitaires. Pour en savoir plus, consultez www.olympic.org/centre-etudes-olympiques  REVUE OLYMPIQUE 67"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 67,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg68.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOLIDARITÉ OLYMPIQUE  RÊVES D’HIVER LA REVUE OLYMPIQUE S’ENTRETIENT AVEC DES ATHLÈTES AU BÉNÉFICE D’UNE BOURSE DU PROGRAMME ACTUEL DE LA SOLIDARITÉ OLYMPIQUE.  SOLIDARITÉ OLYMPIQUE La Solidarité Olympique est l’organisme qui permet aux athlètes de talent d’avoir la même chance de participer et de réussir aux Jeux Olympiques. Elle administre et gère la part des revenus provenant des droits de diffusion des Jeux Olympiques qui revient aux Comités Nationaux Olympiques (CNO). Collaborant en particulier avec les CNO les moins favorisés et leurs associations continentales, la Solidarité Olympique met en place des programmes d’aide. Le plan quadriennal actuel, qui court de 2013 à 2016, dispose d’un budget d’aide et de développement de 438 millions USD, soit une augmentation d’environ 40 % par rapport au budget précédent 2009-2012. C’est la seconde fois que les athlètes de sports d’hiver reçoivent des bourses individuelles. Le programme initial, lancé en vue des Jeux de 2010 à Vancouver, a connu un vif succès et a permis à 325 athlètes (193 hommes et 132 femmes) de 60 CNO de recevoir un financement. Parmi ceux-ci, 227 athlètes se sont qualifiés aux Jeux et, à eux seuls, ont remporté 13 médailles.  68 REVUE OLYMPIQUE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 68,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg69.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOLIDARITÉ OLYMPIQUE  INTERVIEW  CLARA PETERS AVEC L’AIDE DE LA BOURSE DE LA SOLIDARITÉ OLYMPIQUE, CLARA PETERS A POUR OBJECTIF DE DEVENIR LA PREMIÈRE PATINEUSE ARTISTIQUE À REPRÉSENTER L’IRLANDE AUX JEUX OLYMPIQUES D’HIVER.  Photos L’Irlandaise Clara Peters (ci-contre) a terminé 28e dans le programme court de patinage artistique lors des Championnats d’Europe de l’ISU à Sheffield en 2012 (page de gauche).  Comment avez-vous commencé le patinage artistique?  Comment voyez-vous Sotchi 2014? Ce serait un accomplissement! À l’école, quand j’étais plus jeune, nous avons dû disserter sur ce sujet, «Où vous voyezvous dans l’avenir?». J’ai raconté que je voulais participer aux Championnats du monde et d’Europe ainsi qu’aux Jeux Olympiques d’hiver. J’ai réalisé les deux premiers, donc c’est le dernier de ma liste.  J’aimerais avoir une histoire géniale à raconter mais en fait, non: j’ai toujours voulu patiner. En vacances d’hiver avec ma mère, j’ai eu une paire de patins parce que je ne voulais pas skier et c’est comme ça que tout a commencé. Quand avez-vous réalisé que vous pouviez concourir en haut niveau?  À quoi ressemble une semaine typique d’entraînement?  Vers l’âge de sept ans, j’ai commencé à patiner régulièrement. Une année, la patinoire que je fréquentais a organisé une petite compétition et je l’ai remportée. C’est là que j’ai compris que c’était ce que je voulais faire. À 14 ans, je suis allée aux États-Unis pour m’entraîner sérieusement et à 17 ans, j’ai débuté la compétition internationale. Et j’ai vu qu’en continuant à m’entraîner sérieusement avec suffisamment de soutien, j’avais le potentiel pour réaliser mes rêves.  Je suis à la patinoire tous les matins, dès 8h30, du lundi au vendredi. J’y reste près de trois heures puis je fais de la musculation durant environ une heure. Avez-vous un rituel d’avant compétition? Je fais des trucs bizarres… comme toujours mettre mon patin de gauche en premier, qu’il s’agisse d’une compétition ou de l’entraînement. J’ai une liste de morceaux de musique que j’écoute et une peluche que j’emporte à toutes les compétitions. Je l’ai égarée une fois et j’étais complètement paniquée ! Ce sont juste des petites choses qui sont devenues des habitudes.  Comment la bourse de la Solidarité Olympique vous a-t-elle aidée? Énormément. J’ai appris que je pourrais en bénéficier à Noël, en 2012, et c’était fantastique! La bourse a vraiment fait la différence: j’ai pu augmenter mon entraînement, profiter d’excellents équipements, prendre une ou deux leçons supplémentaires par semaine ou suivre un cours de yoga ou de danse. Et c’est génial de pouvoir compter sur le soutien du Conseil Olympique Irlandais et de savoir que je suis prise au sérieux. À ce jour, quel est votre meilleur résultat? Deux choses me viennent à l’esprit. Tout d’abord, ma participation aux Championnats du monde en 2012. Je me suis qualifiée dans le programme court, résultat incroyable pour moi! Tous les  efforts investis ont payé le moment venu. Autre moment fort: la première fois que j’ai représenté l’Irlande au niveau international, même si ce n’était qu’une petite épreuve du Grand Prix junior. Le simple fait d’y participer et de représenter mon pays pour la première fois m’a marquée à jamais.  Comment vous détendez-vous?  Quels sont vos objectifs d’avenir?  Je me sers de Twitter et de Facebook. C’est un excellent moyen de converser avec mes amis du monde entier.  Je veux bien réussir cette saison mais je ne veux pas m’avancer sur des classements ou des résultats. Le plus important est de réaliser les meilleures performances quand je suis sur la glace. Et je serai heureuse de pouvoir me dire que j’ai à chaque fois donné le meilleur de moi-même.  Je suis un peu ringarde mais j’adore rester chez moi lire Le Trône de Fer ou regarder Doctor Who et j’aime faire les magasins! Utilisez-vous les réseaux sociaux ?  «JE NE VEUX PAS M’AVANCER SUR DES RÉSULTATS. LE PLUS IMPORTANT EST DE RÉALISER LES MEILLEURES PERFORMANCES QUAND JE SUIS SUR LA GLACE.»  REVUE OLYMPIQUE 69"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 69,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg70.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOLIDARITÉ OLYMPIQUE  INTERVIEW  VITA ET VALYA SEMERENKO DEPUIS LEUR MÉDAILLE D’ARGENT DÉCROCHÉE EN DUO DANS LE RELAIS FÉMININ DES CHAMPIONNATS DU MONDE DE BIATHLON JUNIOR EN 2005, LES JUMELLES UKRAINIENNES, VITA ET VALYA SEMERENKO, ONT REMPORTÉ D’AUTRES SUCCÈS MONDIAUX EN INDIVIDUEL ET DANS LE RELAIS. ENSEMBLE, ELLES ONT GAGNÉ L’ARGENT ET LE BRONZE AUX CHAMPIONNATS DU MONDE DE BIATHLON 2013. DÉSORMAIS, LES DEUX SŒURS ESPÈRENT AJOUTER DES MÉDAILLES OLYMPIQUES À LEUR COLLECTION CROISSANTE.  VITA Comment, Valya et vous, vous êtes-vous mises au biathlon? Nous faisions du ski de compétition quand notre entraîneur, Grigoriy Ivanovich Shamraj, a été nommé à la tête de l’équipe féminine de biathlon. Il nous a suggéré d’essayer ce sport. «Si ça marche, nous a-t-il dit, vous continuerez sinon vous pourrez toujours revenir au ski.»  VALYA Quand avez-vous réalisé, Vita et vous, que vous pouviez concourir en haut niveau? Au début, nous manquions souvent nos séances d’entraînement. Vous savez ce que c’est quand vous êtes jeunes! Nous préférions rester dehors avec nos amis. Au bout d’un an, l’entraîneur nous a prévenues: «Écoutez Valya et Vita! Vous êtes douées, vous avez ce qu’il faut pour réussir, alors réfléchissez bien. Si vous voulez continuer, si c’est ce que vous souhaitez, il faudra vous entraîner tous les jours.» Nous avons tenté le coup et tout de suite, ça s’est très bien passé. Les entraîneurs se sont mis à parler de ces deux filles de Krasnopol, très bonnes skieuses à l’excellent potentiel. Nous n’y avons pas trop prêté attention, nous avons seulement continué, empilant les heures d’entraînement. Nous aimions vraiment ça, juste ravies de pouvoir skier. Ça doit être bien de courir toutes les deux dans le relais plutôt qu’avec une autre équipière, non ?  Est-ce difficile de concourir contre sa sœur? En fait, sur le terrain il n’y a ni frère ni sœur, seulement des adversaires. Mais une fois la compétition finie, c’est agréable de savoir que vous pouvez compter sur la famille. Il y a toujours des moments difficiles et quand ça vous tombe dessus, vous avez quelqu’un avec qui les partager, quelqu’un de proche qui est toujours là. Une épaule sur laquelle vous appuyer en cas de coup dur.  pas vraiment mais maintenant, je vois bien la différence que ça fait d’être toutes les deux dans la même équipe. Cela veut dire que vous pouvez vous confier quand vous voulez et que vous avez toujours une épaule sur laquelle pleurer. Tout le monde nous répète que nous avons de la chance d’être coéquipières et c’est vrai! Comment était-ce de concourir aux Jeux Olympiques d’hiver de 2006 et de 2010? Aller aux Jeux Olympiques pour la première fois, c’était tout pour moi! Le rêve de tout athlète, depuis tout jeune, c’est de participer aux Jeux. Quand j’ai vu que je m’étais qualifiée et que j’allais à Turin, je ne m’attendais pas à grand-chose. J’avais déjà réalisé mon rêve. J’étais d’autant plus nerveuse que j’étais la benjamine de l’équipe ukrainienne mais le groupe était très sympa et je n’ai pas eu le bourdon. Quand sont arrivés mes deuxièmes Jeux, je savais que je n’étais plus une novice, ni un bébé non plus! Et j’avais donc l’espoir d’obtenir des résultats. Qu’attendez-vous de Sotchi 2014?  Oui, c’est un vrai soutien de la savoir à mes côtés. Quand j’étais petite, je n’y pensais  70 REVUE OLYMPIQUE  Je ne tire jamais de plans sur la comète.  Vous avez toutes les deux reçu une bourse de la Solidarité Olympique. Comment cela vous a-t-il aidées dans votre carrière? La bourse nous a permis d’acheter des équipements ainsi que des médicaments, une crème spéciale pour faciliter la récupération musculaire après l’entraînement. Cela nous a aussi aidées à améliorer notre régime alimentaire. C’est un soutien réel, très appréciable. ➤  Pour moi, avant tout, c’est de rester en forme et en bonne santé. Si j’y parviens, les résultats suivront. Cela dit, j’espère que Sotchi sera une expérience inoubliable! À quoi ressemble une journée d’entraînement? C’est quelque chose comme ça: exercices d’échauffement tôt le matin, puis petit-déjeuner, puis première séance d’entraînement suivie du déjeuner, puis une heure de repos avant la deuxième séance d’entraînement, puis le dîner et enfin une autre séance d’entraînement dans la soirée. Comment la bourse de la Solidarité Olympique vous a-t-elle aidée? La bourse de la Solidarité nous a énormément aidées, cette saison mais aussi l’an dernier. Nous avons amélioré notre régime alimentaire et notre condition physique. Cela nous a aussi permis de séjourner dans un spa pour bien récupérer et d’acheter des vélos et d’autres pièces d’équipement pour bien nous préparer aux prochaines compétitions. Je suis très reconnaissance envers le CIO de l’aide qu’il prodigue aux athlètes comme nous.  Page de droite: À elles deux, Valya (à gauche) et Vita Semerenko (à droite) ont remporté huit médailles aux Championnats du monde."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 70,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg71.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOLIDARITÉ OLYMPIQUE  Comment était-ce de concourir aux Jeux d’hiver de 2010 à Vancouver? C’était mes premiers Jeux Olympiques et j’avais imaginé que ce serait comme de participer aux Championnats du monde. Mais pour une raison ou une autre, j’étais beaucoup plus nerveuse car je voulais absolument faire de mon mieux. Avez-vous déjà couru sur le site olympique à Sotchi? Qu’en avez-vous pensé? Oui, j’ai eu la chance d’essayer la piste. Nous avons eu une épreuve préolympique cette année, une épreuve de Coupe  du monde, et nous avons pu skier pratiquement sur l’ensemble du parcours. C’est un site particulièrement exigeant! Qu’aimez-vous faire en dehors de la compétition et des entraînements?  toujours ouvrir un livre ou un journal et lire un article intéressant, parler à ses amis, à sa famille sur Skype. En fait notre vie est extrêmement variée et nous ne sommes jamais à court. Qui sont vos héros sportifs?  Si j’ai du temps libre quand je suis avec l’équipe nationale ou durant une compétition, j’essaie de dormir ou je sors me promener pour que mon corps se repose et retrouve les bons niveaux d’énergie, pour faciliter la course suivante. Chez moi ou quand je ne suis pas avec l’équipe, j’aime faire les magasins. J’aime aussi la broderie ou réaliser des images en perles. Je ne m’ennuie jamais. On peut  J’ai été longtemps une grande fan des Poirée [Raphaël, septuple champion du monde de biathlon, et sa femme Liv Grete Skjelbreid, vainqueur de deux médailles d’argent à Salt Lake City en 2002]. J’aimais bien les regarder courir; j’adorais leur façon de concourir. Maintenant, je regarde tout le monde avec plaisir pour voir qui fait quoi en compétition."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 71,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg72.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "SOLIDARITÉ OLYMPIQUE  INTERVIEW  PETER ADAM CROOK APRÈS AVOIR CRÉÉ L’ASSOCIATION DE SKI DES ÎLES VIERGES BRITANNIQUES, PETER ADAM CROOK, SPÉCIALISTE DE HALF-PIPE EN SKI, ESPÈRE DEVENIR LE DEUXIÈME ATHLÈTE À REPRÉSENTER L’ÎLE DES CARAÏBES AUX JEUX  Comment vous êtes-vous mis au halfpipe en ski? J’ai commencé le half-pipe en ski à 14 ans quand j’ai déménagé dans le Colorado pour intégrer une école qui proposait un programme équilibré entre les cours et les entraînements de ski et de snowboard. J’avais dû convaincre mes parents de me laisser y aller mais, altruistes comme ils sont, ils m’ont laissé faire ce que j’aime le plus: skier! Et je n’ai pas cessé depuis. Comment voyez-vous Sotchi 2014? Ce serait tout pour moi de représenter les Iles Vierges britanniques aux Jeux à Sotchi en 2014. C’est devenu un gros objectif ces deux dernières années. Je crois que de me retrouver à Sotchi serait une expérience tellement gratifiante et un moment particulièrement excitant de ma vie. Un résultat tangible. J’espère ainsi faire la fierté de mon pays.  Park City, il y a des jours où je skie de 10 à 14 heures puis entre 16 et 21 heures pour skier de nuit. En été, j’essaie de prendre des vacances. J’aime cette période loin de la neige, propice à la récupération physique et qui aide à recharger les batteries en vue de la prochaine saison. J’essaie aussi d’utiliser les rampes sur l’eau du parc olympique de l’Utah, un jour ou deux par semaine. Cela me permet de m’économiser physiquement et de garder du temps pour skier et m’entraîner à de nouvelles figures. Je m’excerce aussi sur un trampoline pour concevoir de nouvelles pirouettes et des figures que je tente d’abord sur l’eau puis sur la neige. En été, je passe aussi énormément de temps sur mon skateboard. C’est risqué pour les blessures mais je ne peux pas m’en empêcher!  Comment la bourse de la Solidarité Olympique vous-a-t-elle aidé? Elle a représenté une aide immense pour moi. Les fonds m’ont permis d’engager un entraîneur à plein temps et m’ont donné aussi la possibilité de me rendre à plus de compétitions pour accroître mon expérience et passer plus de temps sur la neige, ce dont j’ai besoin pour être au top de mon sport. Je reste éternellement reconnaissant de l’attribution de cette bourse par la Solidarité Olympique et j’espère faire honneur à la généreuse assistance qu’elle me prodigue jusqu’aux Jeux d’hiver de 2014. À quoi ressemble une semaine typique d’entraînement? En hiver, c’est un entraînement totalement «sur la neige». En général, je suis sur la route toutes les semaines et parfois, j’en ai une de congé entre les compétitions. À  72 REVUE OLYMPIQUE  Comment occupez-vous votre temps libre? Je fais des tas de photos et de vidéos pour des projets personnels sympas et j’aime passer du temps avec mes amis. Photo: Peter Adam Crook, bénéficiaire de la Solidarité Olympique, prend son envol lors des Championnats du monde de ski acrobatique à Park City, Utah, où il effectue désormais la majeure partie de son entraînement.  /et ma famille ou m’amuser en surf, wakesurfing ou skateboard! Utilisez-vous les réseaux sociaux? J’utilise Facebook (www.facebook. com/BVISKI) et Skype pour rester en contact avec ma famille et mes amis. Je ne vois mes grands-parents, mes parents et mes sœurs qu’une à deux fois par an, donc pour pouvoir être avec eux virtuellement, voir leurs visages et m’entretenir avec eux, c’est vraiment bien. Je suis un fan d’Instagram et de Twitter (@PAdamCrook). Ce sont deux façons pratiques de montrer aux gens ce que je fais tout au long de l’année. Je poste constamment des photos de mes voyages sur Instagram."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 72,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg73.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 73,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg74.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "MES JEUX  INTERVIEW: SERGEY BUTOV  MES JEUX VLADISLAV TRETIAK  í  VLADISLAV TRETIAK, LÉGENDAIRE GARDIEN DE BUT SOVIÉTIQUE DE HOCKEY SUR GLACE ET PORTE-DRAPEAU À DEUX REPRISES AUX JEUX D’HIVER, RETRACE SA CARRIÈRE OLYMPIQUE QUI COMPTE UN RECORD DE TROIS MÉDAILLES D’OR ET UNE D’ARGENT.  M  es premiers Jeux Olympiques, en 1972, sont comme un premier amour qu’on n’oublie jamais! Déjà double champion du monde, j’ai vite compris à quel point les Jeux étaient différents. Je me souviens du déjeuner avec Vyatcheslav Vedenin, skieur de fond qui allait devenir mondialement célèbre à Sapporo, et avec nombre d’athlètes d’élite. En 1972, quand j’ai remplacé Viktor Konovalenko comme gardien de but de premier choix, l’équipe de hockey sur glace soviétique venait défendre son double titre de champion olympique. Viktor était un joueur que j’admirais pour sa cohérence et son courage. Était-ce un défi de le remplacer, moi un novice des Jeux? Certainement, mais dans tous les cas, il y a une forte pression aux Jeux. Même si je me souviens d’un match nul contre la Suède, notre équipe a remporté la médaille d’or plutôt facilement. Nous avons affronté les Tchèques lors du match décisif et bien que les battre ne fût jamais une mince affaire, nous y sommes parvenus sans trop de dégâts.  74 REVUE OLYMPIQUE  À Innsbruck en 1976, pour la première fois, j’ai été porte-drapeau. J’ai été très ému en entrant dans le stade olympique. Les matches ont été très durs. Dans le dernier, les Tchèques menaient 2-0 dans le premier tiers-temps. Ils nous ont attaqués avec un tel acharnement qu’à chaque fois que j’en parle, j’en ai la gorge nouée. Finalement, nous avons gagné 4-3 dans ce qui reste le match le plus extraordinaire de mes quatre participations olympiques. Le «miracle sur glace» date des Jeux de 1980 à Lake Placid lors de notre défaite contre les États-Unis. Plus de 30 ans après, je pense toujours que cela est dû à notre sous-estimation. Nous pensions déjà avoir gagné l’or en entrant sur la patinoire et nous nous en sommes mordu les doigts. Pour avoir laissé passer un but facile, j’ai été remplacé en fin de première période. Notre entraîneur, Viktor Tikhonov, a décidé que je n’étais pas prêt. L’étais-je? Il a admis plus tard son erreur. Je crois que j’aurais pu sauver le match. J’ai de nouveau été porte-drapeau aux Jeux de 1984 à Sarajevo. C’était touchant  car ces Jeux allaient être mes derniers mais cela me donnait aussi d’énormes responsabilités car chez nous, le public attend toujours la victoire du porte-drapeau! Lors de mes six matches à Sarajevo, je n’ai encaissé que cinq buts et cela a été ma performance la plus remarquable aux Jeux. Je voulais faire amende honorable après la défaite à Lake Placid. Cela m’a motivé pour devenir triple champion olympique. Seuls six joueurs de hockey sur glace y sont parvenus dans l’histoire et je suis le seul gardien de but à avoir eu cette chance. ■ SAPPORO 1972 Or: hockey sur glace INNSBRUCK 1976 Or: hockey sur glace LAKE PLACID 1980 Argent: hockey sur glace SARAJEVO 1984 Or: hockey sur glace"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 74,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg75.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 75,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg76.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "La Revue Olympique revient sur les XXIIes Jeux Olympiques d’hiver à Sotchi au travers des événements les plus marquants de ces 17 jours d’action sportive de classe mondiale, de témoignages d’athlètes, de fans, de volontaires et d’officiels sans oublier une sélection d’images saisissantes.  La Revue Olympique est disponible au prix de 10 francs suisses le numéro (frais d’envoi non compris). Pour vous abonner, veuillez choisir la langue de la Revue Olympique (français/anglais/espagnol) et indiquer votre mode de paiement.  ■ FRANÇAIS ■ ANGLAIS ■ ESPAGNOL Veuillez retourner ce coupon à: Abonnements Revue Olympique, Château de Vidy, c. p. 356, 1007 Lausanne, Suisse Fax + 41 21 621 6356  PRÉNOM NOM SOCIÉTÉ ADRESSE  Je désire m’abonner à la Revue Olympique pour un an. Veuillez cocher l’une des cases ci-dessous pour préciser votre adresse. Le coût de l’abonnement pour un an est de:  ■ 50 CHF - En EUROPE ■ 70 CHF - Dans le RESTE DU MONDE Je règle mon abonnement par (cocher une seule case): ■ Virement sur le compte du CIO 243-312883.03Q, à UBS SA, 1002 Lausanne (BIC: UBSWCHZH80A - IBAN CH41 0024 3243 3128 8303 Q); ■ Mandat poste international libellé en francs suisses à l’ordre du Musée Olympique de Lausanne, Service publications, P.O. Box 1121, 1001 Lausanne, Suisse. ■ Carte Visa (veuillez indiquer ci-dessous le détenteur de la carte, son numéro et sa date d’expiration, puis renvoyez ce coupon à l’adresse ci-dessus).  DÉTENTEUR DE LA CARTE Nº DE CARTE VISA  CODE POSTAL  DATE D’EXPIRATION  PAYS  SIGNATURE  E-MAIL  76 REVUE OLYMPIQUE"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 76,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg77.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 77,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg78.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 78,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg79.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "DÉCÈS  VLADIMIR VIKULOV Ancienne star du hockey sur glace soviétique, Vladimir Vikulov est mort à 67 ans. Il avait fait ses débuts en 1964 et avait remporté l’or aux Jeux de 1968 et de 1972 ainsi que sept titres de Championnats du monde de l’IIHF entre 1966 et 1975. JUDIT TEMES Nageuse hongroise, Judit Temes est morte à 82 ans. Aux Jeux de 1952, elle avait remporté le bronze du 100 m nage libre et l’or avec l’équipe du relais 4 x 100 m nage libre. DET DE BEUS La star de hockey néerlandaise a disparu à l’âge de 55 ans. Gardienne de but, elle avait été sélectionnée 105 fois pour son pays et faisait partie de l’équipe qui avait remporté l’or aux Jeux de 1984. Elle s’était retirée de la compétition après avoir décroché le bronze avec son équipe aux Jeux de 1988.  BERTHOLD BEITZ ANCIEN VICE-PRÉSIDENT ET MEMBRE DE LA COMMISSION EXÉCUTIVE  Berthold Beitz est décédé à l’âge de 99 ans. Grand sportif amateur de voile, de tir et d’aviron, il a eu une longue collaboration avec le CIO et le Mouvement olympique. Après 16 années passées en tant que membre du CIO, de 1972 à 1988, puis membre honoraire, il est devenu vice-président et membre de la commission exécutive du CIO, de 1984 à 1988. Il a aussi travaillé au sein des commissions des finances, des nouvelles sources de financement, du Mouvement olympique et de la préparation du XIIe Congrès olympique ainsi que du Conseil de l’Ordre Olympique. Depuis 1989, il était président d’honneur de la fondation du Musée Olympique. Juste avant, il avait présidé le conseil d’administration du CNO d’Allemagne de l’Ouest de 1972 à 1988. Membre du comité exécutif du comité ˇ d’organisation des Jeux de 1972 à Munich, il avait présidé ˇ à l’organisation des régates de voiles de ces Jeux à Kiel. Ci-contre: Berthold Beitz a été vice-président du CIO de 1984 à 1988.  STANISLAV STEPASHKIN Ancien boxeur soviétique, Stanislav Stepashkin est décédé à 73 ans. Il avait remporté l’or des poids plume aux Jeux de 1964 et avait été aussi double champion d’Europe. FAITH LEECH La nageuse australienne Faith Leech est décédée à 72 ans. À seulement 15 ans, elle avait décroché l’or avec l’équipe du relais 4 x 100 m nage libre ainsi que le bronze du 100 m nage libre aux Jeux de 1956.  ˇ  SERGEI BELOV  DEZSÖ GYARMATI JOUEUR LÉGENDAIRE DE WATER-POLO  Célèbre joueur et entraîneur de water-polo hongrois, Dezsö Gyarmati est décédé à 85 ans. Il était le joueur le plus décoré de l’histoire du water-polo et demeure le seul joueur à avoir gagné cinq médailles olympiques durant sa carrière: trois médailles d’or en 1952, 1956 et 1964; une d’argent en 1948 et une de bronze en 1960. Devenu entraîneur de l’équipe nationale hongroise, Dezsö Gyarmati avait ainsi ajouté trois médailles olympiques à son palmarès: l’or en 1976, l’argent en 1972 et le bronze en 1980.  Ancienne gloire du basketball soviétique et champion olympique, Sergei Belov est décédé à 69 ans. Avec l’équipe soviétique, il avait remporté l’or aux Jeux de 1972 à Munich, marquant 20 points dans la célèbre victoire (51 à 50) contre les États-Unis. Il était également titulaire de trois médailles de bronze ainsi que de deux titres de champion du monde de la FIBA. Il avait eu l’honneur d’embraser la vasque des Jeux de 1980 à Moscou et avait été intronisé dans le FIBA Hall of Fame en 2007.  REVUE OLYMPIQUE 79"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 79,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg80.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "LA MISE EN SCÈNE EST DE PIERRE DE COUBERTIN SYLVAIN BOUCHET. ÉDITION JACOBDUVERNET, 2013. ISBN: 9782847244755, 184 PAGES, EN FRANÇAIS.  À droite: le Français Tony Estanguet a remporté sa 3e médaille d’or en canoë slalom à Londres.  OCEANIA: AN ODYSSEY TO THE OLYMPIC GAMES Édité par Lorna Hargreaves. Publié par Uclan Publishing, 2013. ISBN: 9780956528346, 150 pages, en anglais. Pour les athlètes des petits pays en développement, le parcours à suivre pour se rendre aux Jeux Olympiques est un défi bien plus grand que celui rencontré par la plupart de leurs pairs. Ce livre original raconte l’histoire d’athlètes de 15 îles du Pacifique, toutes affiliées aux Comités Nationaux Olympiques d’Océanie (ONOC), qui ont voyagé en vue de s’entraîner et de concourir aux Jeux de 2012 à Londres. Pendant plus de trois ans et demi, ils ont pris part à des camps d’entraînement préalables aux Jeux, dans le nord-ouest de l’Angleterre. Ils ont ainsi pu profiter d’équipements modernes et de qualité et d’un entraînement sportif de pointe. Leurs histoires sont celles de sportifs qui ont effectué le kilomètre de plus, indispensable pour devenir olympien. Chaque histoire est racontée par un jeune journaliste qui a disposé d’une accréditation complète aux Jeux, ce qui donne davantage d’authenticité et de vitalité à l’ouvrage. Désormais, il importe de maintenir l’élan pour que les athlètes de ces îles du Pacifique bénéficient du soutien indispensable en vue de leur participation aux compétitions dans le monde entier.  80 REVUE OLYMPIQUE  En 2013, afin de coïncider avec le 150e anniversaire de la naissance de Pierre de Coubertin, l’historien olympique et spécialiste du cérémonial Sylvain Bouchet nous propose de découvrir une facette surprenante du rénovateur des Jeux Olympiques modernes: Pierre de Coubertin metteur en scène. Ce livre passionnant, préfacé par Jacques Rogge, est le récit du plus grand désir de Coubertin: celui d’allier l’art à l’Olympisme. En effet, pour lui, l’Olympisme était inconcevable sans la participation des artistes. Il décida de  relancer l’idée d’un concours d’art, renouant ainsi avec une tradition de la Grèce antique. Ces concours d’architecture, de littérature, de musique, de peinture et de sculpture ont donné naissance à des œuvres directement inspirées du sport athlétique. Au final, l’histoire du Mouvement olympique révélera que la forme d’association du sport à l’art et à la culture la plus adaptée est celle des spectacles des cérémonies d’ouverture et de clôture des Jeux Olympiques. De la tentative d’introduction des concours artistiques à l’apothéose de la mise en scène des cérémonies olympiques, on suit comme un roman le cheminement d’un esthète et d’un artiste particulièrement curieux.  UNE HISTOIRE D’ÉQUILIBRE  HANDBOOK ON GYMNASTICS  Tony Estanguet. Édition: Outdoor-Editions, 2013. ISBN: 9782953725643, 189 pages (plus DVD), en français.  Édité par Dennis J. Caine. Publié par Wiley-Blackwell, 2013. ISBN: 9781118357583, 200 pages, en anglais.  Récemment devenu membre du CIO après son élection à la commission des athlètes, Tony Estanguet souhaitait laisser une trace de son incroyable parcours. Triple champion olympique de canoë, il décrit avec émotion différentes étapes de sa vie: son éducation, les prémices de sa carrière sportive, sa participation aux Jeux Olympiques de Sydney, Athènes, Beijing et Londres. Sa victoire lors des Jeux de 2012 est relatée plus précisément dans un film documentaire qui accompagne l’ouvrage. Tout au long de ce récit autobiographique, Tony Estanguet nous fait partager sa vision du sport, de la compétition et son ressenti face aux divers défis relevés. Le fil conducteur de son livre mais également de sa vie est, comme le titre l’indique, la notion d’équilibre recherchée: équilibre dans le sport, équilibre dans la performance mais aussi dans sa vie privée.  Dans la série des «Manuels de science et médecine du sport», cette récente publication de la commission médicale du CIO porte sur la gymnastique. L’ouvrage propose des conseils pratiques sur l’entraînement et le soin médical des gymnastes, conçus et édités par des experts internationaux. Les principaux aspects de l’entraînement sont abordés ainsi que les possibilités de minimiser les risques particuliers qu’encourent ces sportifs et le traitement des blessures lorsqu’elles surviennent. Quatre sections portent sur l’évolution de la gymnastique, la croissance et le développement des gymnastes, leurs entraînement et performances ainsi que toutes les questions de médecine sportive. Approuvé par la Fédération Internationale de Gymnastique (FIG), c’est une présentation approfondie de tout ce qui affecte la croissance, la performance, l’entraînement et le soin médical des athlètes qui pratiquent ce sport exigeant.  Sélection proposée par la bibliothèque du CIO, Centre d’Études Olympiques, Quai d’Ouchy 1, Case Postale 1121, 1001 Lausanne, Suisse. Tél. +41 (0)21 621 66 11. Fax +41(0)21 621 67 18. Consultez le site www.olympic.org/bibliotheque pour en savoir plus sur nos services."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 80,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg81.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 81,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg82.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "IAN MILLAR ESPRIT OLYMPIQUE  Ian Millar, cavalier canadien spécialiste du saut d’obstacles, a su faire preuve d’une incroyable détermination. Son rêve de remporter une médaille olympique a duré 36 ans! Sa 1re participation remonte aux Jeux de 1972 à Munich, alors qu’il avait 25 ans. Après s’être contenté de la 4e place en 1984 et 1988 dans l’épreuve de saut par équipes, il a enchaîné les déceptions en 1992, 1996, 2000 et 2004. C’est lors de sa 9e participation en 2008 à Beijing qu’il est monté sur le podium, à 61 ans, décrochant l’argent dans l’épreuve par équipes. Il a ensuite battu le record de 10 participations olympiques en concourant aux Jeux de 2012 à Londres."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 82,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg83.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 83,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg84.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    var windowWidth = payload.width;
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    console.log("Update Zoom: " + newZ + ", " + newX + ", " + newY + ", " + context.state.pageScale);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state) {
    return state.activePanel == "Contents";
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contentsEnabled;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoomEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {
      transform: "scale(" + getters.pageContainerZoomLevel * state.pageScale + ")"
    };
    if (state.zoomLevel !== 1) {
      styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";
    } else {
      styleObject.transformOrigin = "0px 0px";
    }
    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/store/mutations.js


var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }
  console.log("Toggle Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || 2;
  // console.log('update zoom', payload)
  console.log("Update Zoom: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  if (state.zoomLevel < 1) {
    state.zoomLevel = 1;
    console.log("Update Zoom2: " + state.zoomLevel + ", " + state.zoomOriginY + ", " + state.zoomOriginX);
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    isDoublePage: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("mousewheel", this.mouseWheelHandler);
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed) {
          // console.log("is actually panning")
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.wheelDelta > 0) {
      Publish.goToPreviousSection();
    } else {
      Publish.goToNextSection();
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      console.log("WORKING");
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["a" /* default */].config.productionTip = false;

vue_esm["a" /* default */].use(vue_analytics_default.a, {
  id: 'UA-159440454-26',
  router: router
});

/* eslint-disable no-new */
window.Publish = new vue_esm["a" /* default */]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "NZMO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Pg37":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QkI9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S4/L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T53c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U2l4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V6ic":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WN8W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQhR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zf2O":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eJtY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i9d8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oPvi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pXbK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tGyY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uDJ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.294932c6084c22a9d93c.js